import React from 'react';

const Logo = ({ classes, width = 160, height = 100 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    viewBox="0 0 504 290.78"
    className={classes}
    style={{ maxWidth: '100%', height: 'auto' }}
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#D1DE9B"
          fillRule="evenodd"
          d="m445.773 220.021 22.613-125.045-71.8-9.503 1.211-6.696-34.347-4.546-.619-.849c-2.651-3.64-6.317-6.663-10.652-8.76-4.194-2.029-9.018-3.183-14.159-3.183-5.142 0-9.966 1.154-14.16 3.183-4.335 2.097-8.002 5.12-10.653 8.76l-.618.85-34.35 4.545 1.212 6.697-71.802 9.502 22.64 125.045h82.066l1.007.22 24.641 11.094 24.642-11.094 1.006-.22zm27.878-126.7-23.8 131.606-85.683-.001-26.165 11.779-26.164-11.779h-85.626a381686 381686 0 0 1-24.284-134.123L273.73 81.3l-1.212-6.696 37.387-4.948c3.065-3.917 7.118-7.16 11.828-9.44 4.852-2.348 10.402-3.682 16.287-3.682s11.435 1.334 16.286 3.681c4.71 2.28 8.762 5.523 11.827 9.44l37.384 4.95-1.211 6.693 71.8 9.505z"
          clipRule="evenodd"
        />
        <path
          fill="#00402F"
          fillRule="evenodd"
          d="m471.246 92.89-23.434 129.584h-84.161l-25.648 11.546-25.648-11.546H228.25L204.789 92.89l71.801-9.503-1.212-6.696 35.856-4.745c5.679-7.798 15.554-12.96 26.785-12.96s21.106 5.16 26.785 12.96l35.853 4.745-1.211 6.695z"
          clipRule="evenodd"
        />
        <path
          fill="#00AA4F"
          fillRule="evenodd"
          d="m448.331 159.318-4.633 26.099H232.289l-13.624-83.101 26.95-3.655c10.138-1.361 20.318-2.742 30.541-4.102l9.904-1.297.872 4.803.637-8.076.404-4.973 25.589-3.401 1.828-.234 1.871-.255c1.083-2.89 2.911-5.462 5.271-7.566 3.974-3.528 9.436-5.696 15.493-5.696 6.036 0 11.52 2.168 15.473 5.696 2.38 2.104 4.208 4.697 5.292 7.566l1.87.255 1.828.234 25.547 3.401.404 4.973.233 3.082.404 4.994.872-4.824 11.838 1.573 29.542 3.974 25.993 3.528-3.507 26.163c-1.721 9.692-3.464 19.383-5.483 30.839m-46.056-67.48L390.5 90.265l1.127-6.291.276-1.487-30.669-4.081c-1.275-2.636-3.103-4.995-5.335-6.971-4.569-4.081-10.903-6.589-17.874-6.589-6.992 0-13.304 2.508-17.874 6.589-2.253 1.976-4.081 4.335-5.335 6.971l-30.711 4.081 1.403 7.778-9.841 1.318c-20.467 2.721-40.721 5.484-60.848 8.225l19 113.451h82.655l10.414 4.676 11.116 5.016 11.116-5.016 10.414-4.676h82.633a5823 5823 0 0 0 3.401-19.234l.064-.34.085-.446v-.043c1.998-11.137 3.974-22.274 5.951-33.41 3.145-17.832 6.355-42.146 9.521-59.978a30240 30240 0 0 0-58.914-7.97"
          clipRule="evenodd"
        />
        <path
          fill="#96CA4F"
          fillRule="evenodd"
          d="m338.003 216.026 7.877-3.546.657-.296h-17.069l.657.296z"
          clipRule="evenodd"
        />
        <path
          fill="#00AA4F"
          fillRule="evenodd"
          d="M362.488 81.615v.021l-1.828-.255z"
          clipRule="evenodd"
        />
        <path
          fill="#FAC704"
          fillRule="evenodd"
          d="m379.427 96.578-41.423-5.483-41.402 5.462 34.58-8.14-11.435-1.106 13.05-1.211-10.606-6.907 11.987 4.76-5.292-10.711 7.715 9.457 1.424-11.625 1.36 11.604 7.779-9.436-5.356 10.669 12.051-4.718-10.648 6.843 13.092 1.275-11.647 1.084z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M302.21 175.366h12.48l2.173-32.846 3.659 32.846h12.48l7.274-74.671-10.99 1.309-2.723 38.913-3.903-38.124-11.779 1.404-2.254 37.866-4.388-37.075-12.56 1.496zm-35.063-65.959 22.996-2.74.674 11.958-10.475 1.072 1.067 15.11 9.847-.727.668 12.316-9.658.502 1.128 16.303 10.015-.217.689 12.382h-21.239zm-10.385 33.353-10.616-30.852-12.65 1.507 8.57 61.951h9.825l-4.431-34.57 11.309 34.57h11.017l-6.047-65.553-10.685 1.272z"
          clipRule="evenodd"
        />
        <path
          fill="#96CA4F"
          fillRule="evenodd"
          d="m442.538 113.41-15.685 39.234-2.891 22.72h-11.328l2.402-22.295-5.781-43.782 12.922 1.594 1.573 21.976 6.992-20.914zM392.656 153.558l-2.635-.106 2.635-16.068 2.189-13.411.425 29.691zm0-46.354-4.442-.552-10.882 62.804-1.041 5.908h10.308l1.53-9.989 4.527.064 2.678.063.085 9.862h11.264l-1.594-66.608zM372.572 121.04c-1.53-.128-2.635-.446-2.635-.446s-.999-1.042-2.083-1.063c-1.127-.042-2.126.744-2.253 3.571-.149 0-.298-.022-.404-.022.191.617.638 1.998.553 2.232-.659 1.573-1.02 11.009-1.127 20.404-.106 9.436.064 18.809.468 20.339-.234.425-.744.85-1.382 1.148-1.424.68-3.528.701-4.867-1.318.234-1.041.914-10.414 1.36-19.936.468-9.5.766-19.213.234-20.977.213-1.041.574-1.934.765-2.402-.17-.042-.297-.063-.297-.106-.085-.127-.085-3.422-.595-3.422-.468 0-4.187 3.231-5.547 5.335-.829-.701-.617-1.318-.617-1.318s2.763-6.376 5.25-8.012c1.254-.829 2.912-.957 4.314-.851 1.403.085 2.551.404 2.742.468.425.659 1.233 1.764 2.019 1.743.744-.064 2.041-.935 2.041-.935.913.255 1.827.489 2.762.744 0 0 .213 3.698-.701 4.824m5.738-.616c.171-3.294-.148-6.1-.977-8.395-1.7-4.719-5.526-7.418-11.562-8.162l-2.062-.255-15.345-1.913-1.062 73.665h16.407c7.885-.191 11.966-5.101 12.476-15.026l1.148-21.381zM321.245 105.516l-7.32.872-2.18 36.622c-.047.828-.842 1.464-1.775 1.422-.648-.028-1.191-.38-1.447-.87l.018.001c.931.042 1.726-.595 1.774-1.422l2.18-36.622 8.644-1.03zm17.06-2.032.103-1.053-7.521.896-2.636 37.678c-.054.827-.855 1.459-1.786 1.411h-.005c.253.486.79.836 1.434.869.932.049 1.733-.583 1.787-1.41l2.636-37.678zm-19.907 38.407c.086.167.14.351.153.543l3.501 31.428h1.332l-3.403-30.558c-.049-.749-.721-1.366-1.583-1.413m-14.714 31.971h1.297l-9.97-65.22 7.851-.936-.121-1.025-9.16 1.091zm-13.978-37.183-6.728.498c-.728.052-1.387-.311-1.677-.867q.122.006.247-.003l8.105-.598zm2.147 28.739-6.989.153c-.693.014-1.299-.346-1.572-.873l.142.003 8.369-.182zm-22.896-54.713 5.469 63.157h1.355l-5.395-62.287 18.221-2.171-.059-1.033zm-6.665 1.834-5.958.709 3.539 30.23c.094.824-.581 1.562-1.509 1.646-.736.066-1.41-.299-1.705-.865q.135.009.276-.005c.927-.084 1.602-.821 1.508-1.646l-3.539-30.229 7.293-.868zm-13.296 27.628q.073.143.114.3l10.925 33.395h1.145l-10.64-32.526c-.165-.653-.8-1.129-1.544-1.169m-3.7-25.603-.345-.999-9.571 1.14 8.184 59.157h1.31l-8.063-58.288z"
          clipRule="evenodd"
        />
        <path
          fill="#00AA4F"
          fillRule="evenodd"
          d="m439.866 115.62.389-.973-8.296-1.028-6.589 19.669c-.266.795-1.209 1.247-2.104 1.011l-.126-.039c.105.547.548 1.022 1.186 1.191.894.236 1.838-.216 2.103-1.011l6.59-19.669zm-19.213-2.385-.072-1.029-9.384-1.171 5.515 41.854q.026.211-.01.412l-2.216 20.56h1.183l2.092-19.408a1.3 1.3 0 0 0 .01-.412l-5.515-41.854zm-24.127 10.82a1.4 1.4 0 0 0-.021-.322c.671.229 1.116.822 1.08 1.474l.438 29.594c.011.827-.735 1.508-1.667 1.517l-5.34-.21c-.81-.031-1.463-.565-1.592-1.249q.25.086.533.097l5.34.21c.931-.009 1.677-.689 1.667-1.517zm.478 41.192c.638.217 1.087.769 1.082 1.409l.062 7.205h-1.05l-.071-8.357a1.3 1.3 0 0 0-.023-.257m6.42-55.177-13.794-1.715-11.361 65.506h1.259l11.161-64.355 12.761 1.588zm-54.414 63.791h1.075l1.003-69.287 15.52 1.931c3.239.402 5.746 1.414 7.532 3.052-1.796-2.324-4.652-3.714-8.591-4.204l-15.52-1.931z"
          clipRule="evenodd"
        />
        <path
          fill="#00402F"
          fillRule="evenodd"
          d="M424.95 207.147v-8.26l3.431 8.26h3.177v-16.425h-3.145v8.324l-3.463-8.324h-3.146v16.425zm-13.322-4.988c0 1.334-.667 2.161-1.907 2.161-1.207 0-1.874-.827-1.874-2.161v-6.417c0-1.335.667-2.193 1.874-2.193 1.24 0 1.907.858 1.907 2.193zm3.145-6.417c0-3.146-2.033-5.02-5.052-5.02-2.986 0-5.019 1.874-5.019 5.02v6.417c0 3.114 1.97 4.988 5.019 4.988 3.019 0 5.052-1.874 5.052-4.988zm-17.103-5.02h-3.146v16.425h3.146zm-13.1 16.425v-13.598h3.019v-2.827h-9.213v2.827h3.05v13.598zm-22.916-4.988c0 3.05 1.875 4.988 5.02 4.988s5.02-1.938 5.02-4.988v-.604h-3.146v.604c0 1.334-.603 2.161-1.874 2.161s-1.874-.827-1.874-2.161v-6.417c0-1.335.603-2.193 1.874-2.193 1.334 0 1.874.858 1.874 2.193v.603h3.146v-.603c0-3.082-1.875-5.02-5.02-5.02s-5.02 1.938-5.02 5.02zm-6.809-11.437H351.7v11.437c0 1.175-.445 2.161-1.779 2.161-1.271 0-1.78-.986-1.78-2.161v-11.437h-3.145v11.437c0 3.05 1.811 4.988 4.925 4.988 3.081 0 4.924-1.938 4.924-4.988zm-23.584 2.827h1.779c1.271 0 1.97.922 1.97 2.161s-.763 2.065-1.97 2.065h-1.779zm0 13.598v-6.577h.223l3.145 6.577h3.558l-3.273-6.831c1.971-.604 3.241-2.256 3.241-4.606 0-2.987-2.065-4.988-5.02-4.988h-5.019v16.425zm-13.1 0v-13.598h3.018v-2.827h-9.213v2.827h3.05v13.598zm-17.515-9.563c-1.398-.445-2.288-1.08-2.288-2.319 0-1.112.604-1.716 1.875-1.716 1.366 0 1.906.922 1.906 2.193v.476h3.113l.032-.476c0-3.082-1.875-5.02-5.051-5.02-3.145 0-4.988 1.684-4.988 4.575 0 2.763 1.906 4.13 4.606 4.988 1.398.445 2.288 1.048 2.288 2.255-.032 1.081-.699 1.78-1.906 1.78-1.335 0-1.875-.922-1.875-2.161v-.54h-3.145v.54c0 3.05 1.875 4.988 5.02 4.988 3.176 0 5.051-1.779 5.051-4.671 0-2.764-1.97-4.002-4.638-4.892m-19.073 9.563v-8.26l3.431 8.26h3.177v-16.425h-3.145v8.324l-3.463-8.324h-3.145v16.425zm-13.322-4.988c0 1.334-.667 2.161-1.906 2.161-1.208 0-1.874-.827-1.874-2.161v-6.417c0-1.335.666-2.193 1.874-2.193 1.239 0 1.906.858 1.906 2.193zm3.145-6.417c0-3.146-2.033-5.02-5.051-5.02-2.987 0-5.02 1.874-5.02 5.02v6.417c0 3.114 1.97 4.988 5.02 4.988 3.018 0 5.051-1.874 5.051-4.988zm-26.92 6.417c0 3.05 1.875 4.988 5.02 4.988 3.146 0 5.02-1.938 5.02-4.988v-.604h-3.145v.604c0 1.334-.604 2.161-1.875 2.161s-1.874-.827-1.874-2.161v-6.417c0-1.335.604-2.193 1.874-2.193 1.335 0 1.875.858 1.875 2.193v.603h3.145v-.603c0-3.082-1.874-5.02-5.02-5.02s-5.02 1.938-5.02 5.02z"
          clipRule="evenodd"
        />
        <path
          fill="#96CA4F"
          d="M427.791 175.358v-3.847h-.863v-.8h2.607v.8h-.854v3.847zM429.822 175.358v-4.647h.89l.719 1.878.719-1.878h.89v4.647h-.89v-2.391l-.719 1.708-.719-1.708v2.391z"
        />
        <path
          fill="#D1DE9B"
          d="M144.799 229.973c-2.157.132-3.712.676-5.432 1.852-1.266.864-2.075 1.742-2.476 2.683a3.4 3.4 0 0 0-.247.916 11 11 0 0 0-1.299-.423 5 5 0 0 1-.074-.304c-.355-1.884-.245-5.064.328-9.45.383-2.935 3.164-8.775 5.226-12.734a158 158 0 0 1 2.071 3.158c2.271 3.549 3.331 5.453 3.492 5.874.507 1.503 1.208 4.071 1.544 6.099-1.265.515-2.351 1.387-3.133 2.329M122.838 80.967h3.391c.569 0 1.124-.14 1.618-.4l.738.03c1.128 1.067 2.4 1.9 3.791 2.484q1.501.63 3.184.875a83 83 0 0 0-1.285 2.061 340 340 0 0 1-11.437-5.05m-1.971 50.773c-1.412-2.957-3.128-5.631-5.125-7.982-2.541-2.992-5.604-5.538-9.104-7.568-8.457-4.904-17.423-5.918-20.925-6.127-2.224-5.701-3.765-10.599-4.48-13.545 1.912.31 4.62.88 7.256 1.433.764.16 1.53.321 2.278.476.501.115.985.102 1.435.004 1.344 1.625 3.614 4.137 5.804 5.473q.06.038.124.071c.81.424 1.93.725 4.162 1.325 3.673.987 10.356 2.783 22.213 6.945-.755 3.23-2.297 10.078-3.638 19.495m108.483-10.247c-.709-.473-4.467-2.008-7.99-3.402.025-2.441-.387-6.926-3.351-10.139-2.167-2.35-5.201-3.552-9.034-3.582-1.324-1.557-3.142-2.546-5.324-2.881-1.58-.243-3.361-.132-5.114.31-2.036-1.317-4.129-2.09-6.237-2.304a11.4 11.4 0 0 0-6.157 1.088c-2 .975-3.552 2.489-4.589 3.933a130 130 0 0 1-1.565-.522c.182-5.213-2.508-8.459-4.351-10.682l-.16-.194a13 13 0 0 1-.298-.396h.003c.519-.24 1.552-.764 2.515-.928 1.716-.232 2.557.084 3.62.482.462.173.94.352 1.495.491 1.155.29 2.329-.4 2.638-1.549.513-1.904.386-4.007-.368-6.084a13.6 13.6 0 0 0-2.836-4.596h4.851q.311.004.63-.052.012-.001.023-.004l.562-.104q.287-.053.562-.152l13.518-4.918a3.45 3.45 0 0 0 2.076-2.077 3.47 3.47 0 0 0-2.074-4.437l-13.37-4.864a3.5 3.5 0 0 0-.708-.209l-.016-.003-.542-.097a3.5 3.5 0 0 0-.629-.057h-14.68c-.367-8.224-4.725-13.192-8.492-15.97-4.357-3.214-8.8-4.19-8.987-4.23a2.18 2.18 0 0 0-2.612 2.485c.077.47.199 1.324.303 2.272a16 16 0 0 0-1.355-.462c-1.672-.487-4.305-1.019-7.353-.793-3.084.23-5.79 1.176-8.043 2.814a2.185 2.185 0 0 0 .039 3.56c.516.358 1.009.755 1.466 1.177a13 13 0 0 0-2.42.435c-1.935.543-3.725 1.533-5.319 2.942a15.3 15.3 0 0 0-2.754 3.214c-.569.897-.847 1.554-.977 2.034h-7.829c-.671 0-1.323.198-1.878.555a8.493 8.493 0 0 0-7.083 5.209 8.4 8.4 0 0 0-.649 3.244c0 .828.12 1.642.358 2.433-1.972-.312-4.469-.399-6.293-.415-.475-.964-1.252-1.57-2.22-2.099-4.49-2.462-6.53-3.642-7.717-5.732-.738-1.372-1.496-4.518-.413-7.18.741-1.823 2.197-3.048 4.45-3.747q.13-.041.257-.099l.138-.062c.64-.288 1.514-.93 2.047-1.596s3.402-4.714 5.468-10.237c.191-.513.427-1.308.284-2.292-.128-.887-.525-1.703-1.216-2.492-2.065-2.362-8.576-6.384-15.489-8.762-1.918-.664-4.388-1.05-6.504 1.866-1.779 2.28-4.689 7.58-5.3 9.658a2 2 0 0 0-.044.173c-.212 1.023-.059 1.964.09 2.874a16 16 0 0 1 .193 1.5c.381 3.268.368 5.173-.04 6.372-.309.901-.867 1.52-2.379 2.626-1.885 1.233-2.828 1.482-3.519 1.664-.706.186-1.584.417-2.382 1.361q-.085.1-.159.213c-.365.556-1.772 2.915-3.392 6.332-2.03 4.283-3.56 8.43-4.55 12.325-1.509 5.953-1.816 11.31-.913 15.92.364 1.86 2.158 8.573 10.307 20.19-3.539 1.535-6.756 3.351-9.773 5.513-3.07 2.201-5.854 4.692-8.76 7.838-5.07 5.49-9.186 11.773-12.95 19.773l-.024.051c-4.205 9.575-6.91 20.331-7.825 31.107-.877 10.341-.099 20.379 2.251 29.027 2.561 9.422 8.157 17.663 12.272 21.333a2.19 2.19 0 0 0 2.815.081 2.18 2.18 0 0 0 .554-2.757c-.01-.022-1.194-2.228-2.189-6.214a46 46 0 0 1-.997-5.413q.216.4.44.795a49 49 0 0 0 6.266 8.689c4.117 4.565 7.69 6.808 7.84 6.901a2.184 2.184 0 0 0 3.228-2.53c-.013-.039-1.266-3.934-1.777-8.821a38 38 0 0 1-.215-4.134 39 39 0 0 0 1.273 4.075c1.413 3.768 3.377 7.15 5.84 10.052 4.244 5.004 8.531 6.866 8.711 6.942a2.182 2.182 0 0 0 2.94-2.657c-.038-.125-3.052-10.073-.884-21.304q.314 1.004.7 1.987c1.167 2.968 2.828 5.792 4.937 8.396 3.586 4.423 7.244 6.694 7.398 6.788a2.183 2.183 0 0 0 3.285-2.273c-.008-.045-.855-4.557-.047-10.333.471-3.366 1.407-6.463 2.782-9.208a24.1 24.1 0 0 1 6.554-8.107c2.254.028 8.437.662 14.324 6.275 5.366 5.335 5.982 16.732 5.978 24.844-.001 2.12-.208 3.866-.631 5.297-2.289.605-3.963 2.225-5.212 3.655-.189.217-.411.492-.631.796-1.522-.015-2.862.108-4.417.909-1.419.733-2.842 2.092-3.627 3.465-.262.458-.463.885-.562 1.334l-.059.065c-.597.663-1.327 1.752-1.861 2.775-.843 1.617-1.142 2.923-.914 3.993.2.936.804 1.69 1.658 2.068 1.239.549 2.463.093 3.446-.273.193-.072.375-.14.538-.193 1.75-.574 2.019-.512 2.236-.462.602.139 1.298.259 2.585.075 2.197-.315 4.268-1.442 5.954-3.217-.102 1.348.116 2.694.657 3.884.836 1.838 2.358 3.159 4.287 3.718l.174.05c.112.129.245.274.409.437.272.273.478.473.83.76.192.156.396.344.611.543.524.483 1.066.983 1.738 1.326a3.5 3.5 0 0 0 1.579.397c.687 0 1.353-.227 1.938-.676 1.312-1.008 1.952-2.76 2.319-4.105.387-.445.78-1.087 1.054-2.206.301-1.226.327-2.331.185-3.315a10.1 10.1 0 0 0 3.718 2.546c2.547 1.001 3.869.628 5.004.161.106-.043.25-.103.288-.111q-.001-.001.059.006.332.048.587.076c.162.02.301.036.446.059.584.09 1.211.244 1.817.394 1.758.433 3.576.881 4.902-.346.536-.496 1.121-1.412.865-2.96-.144-.87-.56-1.791-1.063-2.643.894.355 1.899.56 2.992.521l.321.194c.237.143.481.29.704.43.818.513 1.481.866 2.025 1.079 1.084.426 2.18.345 3.085-.229 1.196-.758 1.877-2.249 2.022-4.43.104-1.541-.071-2.821-.398-3.883.248.017.521.037.713.057 1.475.839 3.217 1.698 5.141 2.025 2.194.374 4.323.022 6.508-1.073 1.509-.756 3.196-.637 4.552-.542 1.433.1 2.914.204 3.937-.967.425-.486.873-1.343.6-2.662-.322-1.543-1.722-3.098-2.841-4.131-.591-.547-1.559-1.364-2.606-1.937-.315-.779-.964-1.644-2.157-2.548-.952-.719-1.681-1.217-2.801-1.787-.999-.508-4.534-2.106-8.111-1.338-1.392.298-2.335.857-3.167 1.349l-.272.161c-.853.499-.957.447-2.232-.181-1.082-.533-2.488-1.226-4.613-1.456l-.043-.11c-.109-.279-.192-.538-.289-.838l-.139-.426c-2.178-6.499-1.457-9.029-.366-12.858.184-.644.374-1.311.561-2.033 1.31-5.061 7.397-24.401 7.958-26.082l.02-.063.124-.416c.59-1.987.626-2.106 3.536-5.881 3.312-4.232 6.551-9.105 8.04-16.065a59 59 0 0 0 11.707-3.823 63 63 0 0 0 9.842-5.495c3.496-2.383 5.964-4.576 7.287-5.844.625.269 1.477.632 2.592 1.097.316.132.662.284 1.028.445 2.821 1.239 6.679 2.934 9.746 1.148 2.668-1.468 5.325-4.506 7.485-8.558 1.936-3.632 3.266-7.647 3.65-11.017.444-3.903-.383-6.962-2.214-8.182"
        />
      </g>
      <mask
        id="c"
        width={30}
        height={22}
        x={172}
        y={133}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="m172.773 138.494.094.191c2.199 4.479 3.404 9.691 3.582 15.492.007.255.012.424.021.518l.027.27.265-.061c8.81-2.042 15.019-5.262 18.677-7.605 4.053-2.595 6.081-4.793 6.21-5.069l.103-.222-20.636-8.85z"
        />
      </mask>
      <g mask="url(#c)">
        <path fill="url(#d)" d="M172 133h30v22h-30z" />
      </g>
      <mask
        id="e"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g mask="url(#e)">
        <path
          fill="#DB1932"
          fillRule="evenodd"
          d="m174.626 137.309-.672.593s5.544-.523 8.264-1.36c0 0-3.975 4.393-5.649 5.544 0 0 4.812-.419 9.833-2.824 0 0-3.243 3.974-4.602 6.067 1.673-.105 6.38-1.36 9.832-2.72 0 0-2.301 3.138-8.054 8.054 0 0 6.139-1.211 11.39-3.067q.242-.15.471-.297c4.053-2.595 6.08-4.793 6.209-5.069l.104-.222-20.637-8.85z"
          clipRule="evenodd"
        />
        <path
          fill="#F26322"
          d="M188.599 148.258s6.276-.837 12.134-7.218l-1.883-.732s-2.092 3.452-10.251 7.95"
        />
        <path
          fill="#96CA4F"
          fillRule="evenodd"
          d="m129.28 68.91.386-.404h-3.674v1.751l2.253.003q.08-.138.17-.274a7.6 7.6 0 0 1 .865-1.077M169.665 68.506l-.038.191c-.112.55-.266 1.105-.426 1.61l18.613.02 8.016 2.245 1.493-.522-10.153-3.544z"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="f"
        width={97}
        height={168}
        x={76}
        y={50}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M158.489 51.023c.097 1.957.133 3.381-.241 5.249-.257 1.28-.834 3.237-1.361 3.919-1.291-2.625-3.061-4.601-5.266-5.874a11.34 11.34 0 0 0-5.583-1.525c-.588 0-1.155.053-1.642.155l-.481.101.377.315c2.998 2.508 3.726 5.475 3.808 7.524.071 1.784-.319 3.25-.558 3.888-2.202-2.881-4.823-4.341-7.795-4.341-3.343 0-6.042 1.922-6.291 2.257l-.112.151.121.143c.093.114.307.225.826.49 1.48.756 4.863 2.484 6.095 5.464a12.2 12.2 0 0 0-2.394-.249c-3.632 0-5.689 1.841-6.403 3.564-.55 1.329-.361 2.686.493 3.539 1.437 1.474 3.999 2.319 7.029 2.319a16.6 16.6 0 0 0 4.298-.568c.657-.14 1.55-.436 2.496-.75 1.616-.535 3.446-1.143 4.61-1.143l.073.001c-2.243.962-3.906 2.117-4.837 3.362l-.23.309 1.714.307c-.591.441-1.682 1.345-3.05 2.884-1.881 2.114-4.662 5.883-7.228 11.826-.999 2.297-1.776 4.271-2.448 6.21-2.864 8.277-4.911 17.679-6.259 28.746l-.076.63.472-.424c.909-.818 1.61-1.547 2.229-2.188 1.034-1.071 1.849-1.917 3.023-2.539a4.94 4.94 0 0 1 2.304-.597c.287 0 .492.029.618.058-.521 1.032-3.759 5.982-9.463 11.504-3.515 3.403-7.292 6.368-11.225 8.811-4.855 3.015-9.946 5.228-15.135 6.576-1.922.295-3.647.438-5.272.438-5.143 0-8.519-1.522-11.403-3.166l-.436-.248.083.495c.519 3.089 1.74 5.801 3.629 8.06 1.537 1.838 3.522 3.386 5.899 4.602 3.529 1.804 7.052 2.414 8.535 2.603-.993.606-3.67 1.815-7.873 1.815-5.336 0-11.035-1.933-16.939-5.744l-.442-.285.077.521c.509 3.427 1.558 6.482 3.115 9.083a19.7 19.7 0 0 0 5.472 5.942c3.788 2.712 8.723 4.205 13.896 4.205 3.106 0 6.075-.537 8.461-1.52-2.87 4.222-8.155 6.841-12.18 8.314-4.606 1.685-8.611 2.277-8.651 2.283l-.013.469c.068.014 6.867 1.375 13.931 1.683q.527.008 1.049.008c7.79 0 14.891-1.311 21.106-3.896 5.746-2.39 10.717-5.856 14.775-10.301 7.413-8.121 11.518-19.27 11.56-31.396-.04-5.039-.98-11.884-1.383-14.593a10 10 0 0 1-.05-.394c.698 1.028 1.965 3.233 2.955 6.841 1.405 5.128 1.789 11.24 1.141 18.164-.801 7.669-3.767 15.38-8.35 21.714a43.1 43.1 0 0 1-9.53 9.576c-4.041 2.948-8.659 5.233-13.727 6.793l-.205.063.041.21c.013.068.028.088.26.418 4.677 6.632 8.151 14.704 9.783 22.728.095.466.378.744.757.744.387 0 .785-.309.989-.77l.004-.009c3.372-8.524 7.461-14.995 10.297-18.923 3.074-4.256 5.38-6.525 5.403-6.547l.399-.39-.557-.019c-.028-.001-2.497-.089-4.205-.638a51 51 0 0 0 11.326-6.304 52 52 0 0 0 8.153-7.487c4.023-4.569 6.116-8.578 6.661-9.697 3.875-7.956 3.524-18.243-.915-26.843l-4.374-8.59c-3.787-7.678-4.413-11.626-5.121-17.43l-.011-.087-.064-.059c-2.305-2.117-3.396-5.17-3.241-9.075.124-3.116 1.035-5.891 1.333-6.802q.067-.202.097-.301l.111-.383-.39.084a11.2 11.2 0 0 1-2.356.266c-2.519 0-4.133-1.014-5.044-1.865-1.127-1.052-1.657-2.265-1.768-2.985-.245-1.584.369-3.926 1.538-5.162-1.144 3.634.324 5.683 1.05 6.426 1.142 1.17 2.819 1.841 4.601 1.841a6.8 6.8 0 0 0 4.112-1.375c1.369-1.031 2.377-2.549 2.992-4.513l.04-.129-.088-.1c-2.167-2.458-2.638-5.395-2.667-5.587-.007-.187.031-.238.04-.246.019-.021.076-.033.154-.033.07 0 .158.009.277.027q.312.048.63.048c1.131 0 2.072-.448 2.687-.788.706-.413 1.346-.909 1.965-1.388 1.052-.815 2.045-1.584 3.358-2.008l.24-.078-.091-.235c-.708-1.819-2.643-4.093-4.621-4.773l.111-.249c.835-1.866 1.339-2.992 1.889-5.764 1.342-5.943-.878-10.643-2.977-13.54-1.869-2.578-3.876-4.064-4.286-4.103l-.273-.026z"
        />
      </mask>
      <g mask="url(#f)">
        <path fill="url(#g)" d="M76 50h98v168H76z" />
      </g>
      <mask
        id="h"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g fillRule="evenodd" clipRule="evenodd" mask="url(#h)">
        <path
          fill="#FFE639"
          d="M168.358 157.489c-.706-11.925-5.727-22.281-5.727-22.281 7.218 11.297 5.727 22.281 5.727 22.281m1.883-6.982c-2.197-13.128-10.278-18.986-11.611-32.402 0 0-1.883 5.727 1.307 16.345 2.345 6.586 6.937 21.962-3.04 37.862-4.048 6.45-10.475 12.968-20.391 18.99 0 0 36.559-11.297 33.735-40.795"
        />
        <path
          fill="#FFE639"
          d="M96.966 188.844s23.641 3.138 39.227-12.762 11.611-38.076 10.669-44.457c0 0 5.754 52.826-49.896 57.219"
        />
        <path
          fill="#FAC704"
          d="M168.739 89.757c-1.728 0-3.318-.375-4.726-1.114-1.709-.794-2.185-2.43-2.147-2.606l.042-.187h.222l.061.015.028.016c.03.018.757.433 2.175.848 1.65.423 3.368.431 5.358.441 1.599.008 3.413.017 5.464.255l.223.026-.012.224c-.007.12-.063.273-.643.6a10 10 0 0 1-1.43.642c-1.045.383-2.694.84-4.615.84M179.735 87.305c-.591-.04-1.479-.157-2.507-.294-1.911-.254-4.289-.57-6.416-.615h-.275c-3.603 0-6.624-.413-8.288-1.136l-.639-.277.675-.172c1.76-.448 2.397-.86 3.452-1.538 1.86-1.203 2.685-1.692 4.435-1.692.497 0 1.102.036 2.027.12.23.02 5.676.564 7.769 5.269l.16.36z"
        />
        <path
          fill="#FFE95F"
          d="M168.633 79.202c-.707-1.816-2.636-4.085-4.611-4.769-1.631-.349-3.787-.737-5.233-.737q-.363.001-.721.014c2.315.87 5.514 2.918 7.165 7.731 1.013-.785 1.983-1.517 3.251-1.926l.241-.077z"
        />
        <path
          fill="#FFEB75"
          d="m179.735 87.305.393.026-.16-.361c-2.093-4.705-7.539-5.248-7.769-5.27-.925-.083-1.53-.12-2.027-.12-1.75 0-2.575.49-4.435 1.693-1.055.679-2.287 1.355-4.047 1.804 0 0 1.648.314 4.943-1.02s8.316-1.02 10.748 2.903c.189.025 1.763.306 2.354.345"
        />
      </g>
      <mask
        id="i"
        width={73}
        height={8}
        x={125}
        y={68}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="m169.665 68.506-.038.191c-.359 1.779-1.169 3.609-1.178 3.627l-.084.191.177.108c.016.011 1.652 1.036 2.55 2.842l.066.132h16.013l10.152-3.547-10.152-3.544zm-43.674 0v7.091h2.289l-.152-.337c-.596-1.314-1.029-3.297.287-5.274.259-.389.533-.732.865-1.077l.386-.403z"
        />
      </mask>
      <g mask="url(#i)">
        <path fill="url(#j)" d="M125 68h73v8h-73z" />
      </g>
      <mask
        id="k"
        width={6}
        height={10}
        x={119}
        y={67}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M119.593 76.026h5.162v-8.042h-5.162z" />
      </mask>
      <g mask="url(#k)">
        <path fill="url(#l)" d="M119 67h6v10h-6z" />
      </g>
      <mask
        id="m"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g mask="url(#m)">
        <path
          fill="#DEDFE0"
          fillRule="evenodd"
          d="M120.377 69.71h4.378v-1.726h-5.163v8.043h.785z"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="n"
        width={6}
        height={8}
        x={113}
        y={68}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M116.996 68.506a3.55 3.55 0 0 0-3.545 3.544 3.55 3.55 0 0 0 3.545 3.547h1.36v-7.091z"
        />
      </mask>
      <g mask="url(#n)">
        <path fill="url(#o)" d="M113 68h6v8h-6z" />
      </g>
      <mask
        id="p"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g fillRule="evenodd" clipRule="evenodd" mask="url(#p)">
        <path
          fill="#F8A88B"
          d="M116.995 68.506a3.548 3.548 0 0 0-3.447 4.368 3.55 3.55 0 0 1 3.447-2.72h1.361v-1.648z"
        />
        <path
          fill="#7C8180"
          d="M75.801 113.125c-2.415-3.443-8.832-12.589-10.612-21.835l-.002-.01c-.494-3.254-.088-7.478 1.208-12.555 1.868-7.307 4.962-14.006 5.878-15.62l.086-.151.17.035c.898.188 4.547 1.855 8.798 4.38 1.55.92 4.306 2.704 6.973 4.43.91.587 1.816 1.174 2.675 1.727.873.563 1.698 1.086 2.426 1.547.826.523 1.54.975 1.997 1.279.48.298.908.603.805 1.016-1.233 4.813-4.885 12.789-5.55 13.453-.139.15-.348.168-.494.168-.348 0-.9-.115-1.9-.322-.647-.133-1.45-.3-2.478-.493-4.714-.896-8.01-1.314-10.375-1.314-2.26 0-3.604.386-4.105 1.181-.57 1.124.067 4.554 1.751 9.415 1.343 3.884 3.286 8.659 5.331 13.101l.132.288-.314.047c-.287.043-.953.174-1.488.279l-.625.121-.15.028zM94.97 49.036c-5.135-4.04-12.751-6.561-12.827-6.586l-.241-.08.094-.235c.863-2.156 2.77-5.237 3.273-5.911q.092-.124.174-.24c.375-.516.67-.925 1.268-.925.167 0 .349.033.558.1.62.154 2.807.852 5.62 2.285 1.36.692 3.155 1.662 4.983 3.032.564.372 1.044 1.03.71 1.768-.101.278-1.601 4.35-3.268 6.74l-.145.208zM87.03 66.527c-5.998-3.867-11.343-6.28-11.396-6.303l-.5-.224.505-.214c3.15-1.322 5.136-3.753 5.907-7.224.502-2.258.49-4.868-.035-7.98l-.06-.354.35.082c1.881.444 7.681 2.447 11.875 6.334l.22.205-.249.168c-2.557 1.726-5.3 3.825-6.266 6.295-1.036 2.642-1.034 5.899.004 8.938l.221.647z"
        />
      </g>
      <mask
        id="q"
        width={12}
        height={20}
        x={84}
        y={195}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M95.252 195.159c-5.759.467-10.006 3.103-10.471 3.401l-.084.054-.021.098c-.172.811-.71 9.852 2.831 14.902l.369.526.063-.64c.522-5.319 2.369-9.716 3.827-12.467 1.638-3.091 3.242-5.033 3.675-5.469l.452-.458z"
        />
      </mask>
      <g mask="url(#q)">
        <path fill="url(#r)" d="M83 195h13v20H83z" />
      </g>
      <mask
        id="s"
        width={16}
        height={28}
        x={143}
        y={188}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M157.676 189.033c-.348.099-2.68 1.545-5.559 4.182-2.587 2.369-6.244 6.292-8.974 11.531l-.045.086.028.092c.148.503 1.634 3.187 3.025 5.58 1.071 1.842 2.932 4.968 3.363 5.22.226.132.448.198.656.198.517 0 .858-.389 1.07-.683.309-.429.564-1.634.834-2.909.123-.585.24-1.138.354-1.564 1.935-7.48 5.544-21.444 5.544-21.444l.104-.402z"
        />
      </mask>
      <g mask="url(#s)">
        <path fill="url(#t)" d="M143 188h16v28h-16z" />
      </g>
      <mask
        id="u"
        width={23}
        height={46}
        x={66}
        y={175}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M78.636 176.039c-2.163 1.39-5.388 4.287-8.466 10.187-1.968 3.775-3.416 8-3.777 11.026-.887 6.888.261 12.542 1.381 16.073 1.214 3.832 2.62 6.002 2.678 6.093l.463.706-.026-.844c-.189-6.414.468-12.235 1.955-17.3 1.222-4.161 3.012-7.85 5.32-10.967 3.524-4.756 7.444-7.171 10.112-8.358l.503-.224-.507-.214c-4.051-1.705-7.277-3.827-9.329-6.136l-.135-.152z"
        />
      </mask>
      <g mask="url(#u)">
        <path fill="url(#v)" d="M65 175h24v46H65z" />
      </g>
      <mask
        id="w"
        width={18}
        height={25}
        x={59}
        y={168}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M74.248 168.443c-.477.17-3.655 2.93-6.815 7.023-2.938 3.802-6.65 9.78-7.654 16.665l-.09.618.479-.401c.618-.52 1.562-.934 2.321-1.266.532-.233.951-.417 1.157-.592l.047-.039.095-.248c2.769-7.306 6.972-13.593 12.153-18.179l.136-.12-.079-.163-.1-.2c-.292-.588-1.067-2.15-1.345-2.951l-.078-.227z"
        />
      </mask>
      <g mask="url(#w)">
        <path fill="url(#x)" d="M59 168h18v25H59z" />
      </g>
      <mask
        id="y"
        width={81}
        height={96}
        x={36}
        y={116}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M71.374 119.692c-7.046 3.059-13.319 8.24-18.647 15.4-4.765 6.404-8.623 14.151-11.467 23.027-2.574 8.034-4.184 16.704-4.656 25.07-.459 8.133.169 15.59 1.815 21.566l.468-.066c-.138-10.093 2.152-18.359 4.096-23.515 1.64-4.35 3.395-7.457 4.381-8.878-1.904 6.841-2.508 13.137-1.845 19.214.725 6.636 2.954 13.013 6.816 19.494l.442-.133c-.312-6.896.404-13.502 2.126-19.634a54 54 0 0 1 6.199-14.067c2.17-3.465 5.905-8.494 11.384-12.774.382-.297.404-.315.426-.419l.008-.042-.006-.043c-.858-5.433-.175-10.097.053-11.392 1.433 1 7.38 5.114 9.138 5.712l.826.28-.568-.662c-.492-.571-1.565-2.904-2.305-6.103-.606-2.611-1.147-6.481-.367-10.302 4.838 4.143 10.341 6.243 16.365 6.243h.003c5.885-.001 11.16-2.038 14.548-3.746 3.653-1.844 6.111-3.792 6.26-4.034l.054-.088-.026-.099c-.332-1.243-1.386-4.546-4.002-8.363-2.693-3.93-6.139-7.105-10.236-9.437-5.722-3.353-11.76-5.052-17.947-5.052-4.58 0-9.193.982-13.336 2.843"
        />
      </mask>
      <g mask="url(#y)">
        <path fill="url(#z)" d="M36 116h81v96H36z" />
      </g>
      <mask
        id="A"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g mask="url(#A)">
        <path
          fill="#00AA4F"
          fillRule="evenodd"
          d="M199.356 123.74c-.729 0-.932-.795-.985-1.136-.112-.716.005-1.719.329-2.824.356-1.215.937-2.478 1.68-3.652 1.326-2.096 3.763-4.869 7.838-6.174l.015-.004.014-.003a6.3 6.3 0 0 1 1.164-.106c1.735 0 3.343.677 4.528 1.906 1.472 1.528 2.247 3.797 2.305 6.746l.006.335-.318-.104c-.991-.324-1.818-.635-2.618-.935-1.28-.481-2.491-.936-4.313-1.436-.215.18-.598.512-1.099.947-2.342 2.033-6.699 5.814-8.074 6.335q-.249.105-.472.105"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="B"
        width={132}
        height={64}
        x={95}
        y={80}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="m99.696 80.971-.055.006-.216.139-.029.067c-.481 1.144-1.986 4.941-3.085 7.713-.433 1.093-.797 2.01-.996 2.508l-.052.129.088.108a40 40 0 0 0 2.994 3.277c1.374 1.339 2.421 2.127 3.111 2.344 1.05.394 4.593 1.607 8.694 3.012 6.611 2.264 14.837 5.081 17.841 6.246l.246.096.07-.255c1.097-3.994 2.895-9.607 4.653-13.378l.101-.216-.217-.101c-3.481-1.614-10.192-4.644-15.585-7.077-4.307-1.944-8.027-3.624-8.778-3.984-1.18-.568-2.35-.919-4.536-.919-1.128 0-2.518.092-4.249.285m76.553 28.588c-.006.013-.666 1.412-2.193 2.789-1.404 1.266-3.855 2.775-7.553 2.775-.765 0-1.565-.064-2.379-.191l-.263-.041-.011.266c-.141 3.187 1.29 6.831 1.351 6.984l.037.093 13.74 5.765 13.087 5.519c1.851.77 3.745 1.529 5.579 2.264 2.618 1.048 5.325 2.133 7.949 3.267 2.354 1.014 8.876 3.807 9.944 4.261.811.343 1.552.518 2.2.518.688 0 1.292-.194 1.795-.576.512-.388 2.331-1.943 4.251-5.659a33 33 0 0 0 2.255-5.696c.405-1.416.804-3.244.4-3.908a.56.56 0 0 0-.484-.283c-.148 0-.305.052-.482.159l-.009.005c-4.399 2.914-6.764 9.366-7.747 12.211.26-2.175 1.09-4.723 2.365-7.203 1.501-2.919 3.407-5.307 5.101-6.387l.357-.228-.38-.186c-5.704-2.8-15.796-5.946-15.896-5.978l-.142-.044-.101.106c-1.634 1.701-4.866 4.615-6.938 5.765-1.039.578-1.983.871-2.805.871-1.567 0-2.707-1.075-3.39-3.195l-.11-.341-.272.234c-.973.836-1.948 1.26-2.899 1.26-1.96 0-3.599-1.82-4.616-5.124l-.144-.469-.279.403c-.863 1.245-1.784 1.875-2.739 1.875-1.091 0-1.969-.817-2.396-1.305-2.412-2.726-1.879-7.552-1.603-8.695l.047-.195-.185-.079c-2.278-.984-4.119-1.721-4.137-1.729l-.21-.083z"
        />
      </mask>
      <g mask="url(#B)">
        <path fill="url(#C)" d="M95 80h132v64H95z" />
      </g>
      <mask
        id="D"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g fill="#00AA4F" fillRule="evenodd" clipRule="evenodd" mask="url(#D)">
        <path d="M192.913 121.431c-.632 0-1.303-.523-1.75-1.366-.436-.819-1.604-3.865 1.632-8.656l.009-.013c1.059-1.364 2.391-2.594 3.751-3.464 1.577-1.01 3.196-1.543 4.68-1.543 1.308 0 2.523.402 3.613 1.194l.298.217-.32.183c-8.011 4.57-10.054 10.345-10.823 12.525-.181.587-.578.923-1.09.923M185.42 118.377c-.566 0-1.115-.449-1.507-1.232-.537-1.07-.713-2.596-.485-4.185.282-1.958 1.16-3.969 2.54-5.815 1.491-1.874 3.444-2.903 5.503-2.903 1.286 0 2.545.407 3.546 1.145l.36.266-.422.151c-.006.002-.656.24-1.609.971-.882.675-2.211 1.921-3.534 4.022-1.052 1.628-1.929 3.496-3.029 6.45l-.004.01-.005.01c-.441.917-.98 1.11-1.354 1.11" />
      </g>
      <mask
        id="E"
        width={15}
        height={21}
        x={159}
        y={90}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M162.63 91.978a20 20 0 0 0-.98 1.589c-1.366 2.677-2.088 5.597-2.088 8.442 0 3.367.895 6 2.521 7.411 1.102.958 2.519 1.463 4.096 1.463 1.583 0 3.189-.53 4.407-1.454 1.751-1.33 2.836-3.294 3.054-5.531.216-2.211-.469-4.388-1.878-5.973-2.061-2.346-3.214-4.25-3.858-6.366l-.112-.369-.28.265c-2.225 2.115-2.835 5.293-3.095 6.824-.78-1.931-.835-4.478-.142-7.271l.05-.201-.092-.094a.34.34 0 0 0-.248-.105c-.219 0-.535.166-1.355 1.37"
        />
      </mask>
      <g mask="url(#E)">
        <path fill="url(#F)" d="M159 90h15v21h-15z" />
      </g>
      <mask
        id="G"
        width={11}
        height={8}
        x={187}
        y={68}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="m187.12 68.744-.003.078c0 .761.502 1.401 1.191 1.615a1.69 1.69 0 0 0 0 3.229 1.69 1.69 0 0 0-1.191 1.613l.003.08.011.238h.04l10.152-3.547-10.132-3.537z"
        />
      </mask>
      <g mask="url(#G)">
        <path fill="url(#H)" d="M187 68h11v8h-11z" />
      </g>
      <mask
        id="I"
        width={50}
        height={70}
        x={120}
        y={148}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M152.039 155.11c-.801 7.669-3.767 15.38-8.35 21.714a43.1 43.1 0 0 1-9.53 9.576c-4.041 2.948-8.659 5.233-13.727 6.793l-.205.063.041.21c.013.068.028.088.26.418 4.677 6.632 8.151 14.704 9.783 22.728.095.466.378.744.757.744.387 0 .785-.309.989-.77l.004-.009c3.372-8.524 7.461-14.995 10.297-18.923 3.074-4.256 5.38-6.525 5.403-6.547l.399-.39-.557-.019c-.028-.001-2.497-.089-4.205-.638a51 51 0 0 0 11.326-6.304 52 52 0 0 0 8.153-7.487 50 50 0 0 0 5.106-6.896c1.241-4.117 1.847-8.335 1.459-11.988-.724 2.179-1.48 4.356-2.948 6.488a31.2 31.2 0 0 0-.279-8.778c-1.858 10.448-7.368 17.906-15.888 22.897 3.413-4.031 5.513-8.666 6.523-13.808-1.627 2.633-3.626 4.631-6.175 5.69 1.941-4.984 3.405-15.131 1.835-21.355-.049 1.169-.357 5.372-.471 6.591"
        />
      </mask>
      <g mask="url(#I)">
        <path fill="url(#J)" d="M120 148h50v70h-50z" />
      </g>
      <mask
        id="K"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g fill="#DB1932" mask="url(#K)">
        <path d="M101.935 190.685c7.79 0 14.891-1.311 21.105-3.896 5.747-2.39 10.718-5.856 14.776-10.301 4.814-5.274 8.233-11.826 10.05-19.094-3.367 7.335-6.671 11.698-13.242 16.073 2.824-4.289 5.251-8.542 7.101-15.525-2.547 4.933-8.453 9.685-12.975 11.169 3.484-3.017 9.801-10.729 11.587-19.289-3.52 5.548-8.461 9.717-15.124 12.211 5.177-5.125 8.739-10.975 10.402-17.675-3.615 5.185-8.613 8.858-15.19 10.807 4.859-4.073 8.289-8.922 9.911-14.752-8.467 10.498-22.735 17.383-31.547 10.994a31 31 0 0 1-3.064.158c-5.143 0-8.52-1.522-11.403-3.166l-.436-.249.083.496c.519 3.089 1.74 5.801 3.629 8.06 1.537 1.837 3.522 3.386 5.899 4.601 3.529 1.804 7.052 2.415 8.535 2.603-.992.606-3.67 1.816-7.873 1.816-5.336 0-11.035-1.933-16.939-5.744l-.442-.285.078.52c.508 3.428 1.556 6.483 3.115 9.083a19.75 19.75 0 0 0 5.47 5.943c3.79 2.711 8.725 4.205 13.897 4.204 3.106 0 6.075-.536 8.461-1.52-2.87 4.223-8.154 6.841-12.181 8.315-4.606 1.685-8.61 2.277-8.65 2.283l-.013.469c.068.014 6.867 1.375 13.93 1.683.35.005.704.008 1.05.008" />
        <path d="M85.497 145.264c3.297 1.598 6.829 2.404 10.559 2.404h.003c2.247 0 4.404-.298 6.402-.76-5.747-3.057-11.537-3.3-16.964-1.644M82.105 158.211l.827.28-.57-.661c-.49-.571-1.564-2.905-2.305-6.103a30 30 0 0 1-.626-3.769c-2.204 1.29-4.309 2.87-6.285 4.666 1.691 1.178 7.265 5.012 8.96 5.587" />
      </g>
      <mask
        id="L"
        width={79}
        height={92}
        x={36}
        y={120}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M67.248 121.778c-5.387 3.122-10.257 7.584-14.521 13.314-4.765 6.404-8.623 14.151-11.467 23.027-2.574 8.034-4.184 16.704-4.656 25.07-.459 8.133.169 15.59 1.815 21.566l.468-.066c-.138-10.093 2.152-18.359 4.096-23.515 1.64-4.35 3.395-7.457 4.381-8.878-1.904 6.841-2.508 13.137-1.845 19.214.725 6.636 2.954 13.013 6.816 19.494l.442-.133a68 68 0 0 1-.022-5.666c-8.697-56.694 30.194-81.843 54.329-59.722a39 39 0 0 0 3.523-1.561 40 40 0 0 0 3.951-2.286c-8.178-13.986-23.677-17.545-30.144-14.299 10.094-.048 20.711 7.113 23.325 13.264-22.158-16.632-59.305-9.217-68.115 43.153 1.253-30.288 17.331-55.685 35.383-63.135-2.756 0-5.358.446-7.759 1.159"
        />
      </mask>
      <g mask="url(#L)">
        <path fill="url(#M)" d="M36 120h79v92H36z" />
      </g>
      <mask
        id="N"
        width={16}
        height={33}
        x={57}
        y={152}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M57.372 184.277a53.4 53.4 0 0 1 3.73-7.107c2.17-3.465 5.905-8.494 11.384-12.774.382-.297.404-.315.426-.419l.008-.042-.006-.043c-.795-5.033-.267-9.405-.003-11.052-9.074 8.374-15.339 21.29-15.539 31.437"
        />
      </mask>
      <g mask="url(#N)">
        <path fill="url(#O)" d="M57 152h16v33H57z" />
      </g>
      <mask
        id="P"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g mask="url(#P)">
        <path
          fill="#00AA4F"
          d="M110.47 182.337c5.06-2.272 12.254-9.078 16.371-16.214-6.904 4.708-17.496 9.912-32.14 4.472 10.042-1.647 16.763-4.001 22.83-9.65-9.65 2.04-18.75-.496-23.85-5.282 7.453.471 14.122-1.098 15.954-2.02-3.904.577-7.621-.039-10.68-2.257a31 31 0 0 1-3.063.158c-5.143 0-8.52-1.522-11.403-3.166l-.436-.249.083.495c.52 3.089 1.74 5.801 3.63 8.06 1.536 1.838 3.521 3.386 5.898 4.602 3.53 1.804 7.052 2.414 8.535 2.603-.992.606-3.67 1.815-7.873 1.815-10.314-.414-17.38-6.029-17.38-6.029l.077.521c.508 3.427 1.556 6.483 3.115 9.083a19.7 19.7 0 0 0 5.47 5.942c3.79 2.712 8.725 4.205 13.897 4.205 3.106 0 6.075-.536 8.461-1.52-2.87 4.222-8.154 6.841-12.18 8.314-4.607 1.685-9.659 2.548-9.699 2.554l1.035.199c.068.014 6.867 1.374 13.93 1.683.35.005.704.008 1.05.008 18.776-.168 25.262-9.896 25.262-9.896s-8.264 2.929-16.894 1.569"
        />
        <path
          fill="#FAA41A"
          d="M137.043 124.297c-.222.353-4.284 6.214-9.685 11.443-3.516 3.404-7.292 6.368-11.225 8.811-4.855 3.015-9.947 5.228-15.135 6.577q-1.059.162-2.044.263l-.108.058c24.167.47 35.074-20.641 38.197-27.152"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M154.911 76.136c2.103 0 3.806 1.832 3.806 4.09s-1.703 4.09-3.806 4.09-3.804-1.832-3.804-4.09 1.702-4.09 3.804-4.09"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="Q"
        width={36}
        height={29}
        x={131}
        y={50}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M158.489 51.023c.097 1.957.133 3.381-.241 5.249-.257 1.28-.834 3.237-1.361 3.919-1.291-2.625-3.061-4.601-5.266-5.874a11.34 11.34 0 0 0-5.583-1.525c-.588 0-1.155.053-1.642.155l-.481.101.377.315c2.998 2.508 3.726 5.475 3.808 7.524.071 1.784-.319 3.25-.558 3.888-2.202-2.881-4.823-4.341-7.795-4.341-3.343 0-6.042 1.922-6.291 2.257l-.112.151.121.143c.093.114.307.225.826.49 1.48.756 4.863 2.484 6.095 5.464a12.2 12.2 0 0 0-2.394-.249c-3.632 0-5.689 1.841-6.403 3.564-.55 1.329-.361 2.686.493 3.539 1.437 1.474 3.999 2.319 7.029 2.319a16.6 16.6 0 0 0 4.298-.568c.657-.14 1.55-.436 2.496-.75 1.236-.409 4.293-1.012 5.385-1.201 6.172-2.999 12.394-1.016 12.394-1.016s1.519-1.983 2.328-6.161c1.342-5.943-.878-10.643-2.977-13.54-1.869-2.578-3.876-4.064-4.286-4.103l-.273-.026z"
        />
      </mask>
      <g mask="url(#Q)">
        <path fill="url(#R)" d="M131 50h37v29h-37z" />
      </g>
      <mask
        id="S"
        width={17}
        height={22}
        x={77}
        y={45}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M77.196 61.018c1.221.614 3.554 1.768 5.416 2.83-.5-7.747 3.003-12.564 7.346-16.011-1.989-1.053-4.29-2.301-6.227-2.733.488 6.814-.887 12.147-6.535 15.914m7.657 4.148q.422.256.851.522c.43.195.958.497 1.484.735.065-.151.001-.424.067-.575-.905-2.923-.864-6.011.126-8.535.966-2.47 3.925-4.715 6.482-6.442 0 0-1.028-1.04-1.43-1.186-5.822 4.479-8.019 7.044-7.58 15.481"
        />
      </mask>
      <g mask="url(#S)">
        <path fill="url(#T)" d="M77 45h17v22H77z" />
      </g>
      <mask
        id="U"
        width={16}
        height={14}
        x={83}
        y={35}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M83.118 42.795a59 59 0 0 1 4.931 2.084l3.866-7.915c-2.024-.962-3.617-1.51-4.363-1.727zm8.469 3.956a34 34 0 0 1 2.406 1.554 49 49 0 0 0 4.025-7.724 3 3 0 0 0-.147-.106 29 29 0 0 0-2.277-1.535z"
        />
      </mask>
      <g mask="url(#U)">
        <path fill="url(#V)" d="M83 35h16v14H83z" />
      </g>
      <mask
        id="W"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g mask="url(#W)">
        <path
          fill="#ADB0B1"
          d="M93.932 75.453c-.363-.232-7.359-4.67-7.74-4.916 3.66 8.682-.28 17.225-7.602 18.375 1.055.171 5.033.775 6.276 1.011 1.027.193 3.032.514 3.313.567 1.49.471 7.14-14.043 5.753-15.037"
        />
      </g>
      <mask
        id="X"
        width={19}
        height={50}
        x={66}
        y={63}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M66.526 89.051c-.104 6.277 5.504 18.373 10.121 23.327-7.14-14.513-10.016-24.687-1.24-23.518h.009c-.581-6.843 2.516-14.841 9.192-19.442a128 128 0 0 0-3.28-2.05c-3.267-1.941-6.178-3.374-7.758-4.018-4.452 9.881-6.939 19.425-7.044 25.701"
        />
      </mask>
      <g mask="url(#X)">
        <path fill="url(#Y)" d="M66 63h19v50H66z" />
      </g>
      <mask
        id="Z"
        width={15}
        height={11}
        x={148}
        y={85}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M150.271 86.181a1.7 1.7 0 0 0-.303.291c-.23.28-.455.536-.635.868-1.144 3.634.324 5.683 1.05 6.426 1.142 1.17 2.819 1.841 4.601 1.841a6.8 6.8 0 0 0 4.112-1.375c1.369-1.031 2.377-2.549 2.992-4.513l.04-.129-.088-.1a11 11 0 0 1-1.578-2.358c-1.436 1.32-5.375 2.746-8.806-.73-.254-.294-.532-.422-.802-.422-.203 0-.402.072-.583.201"
        />
      </mask>
      <g mask="url(#Z)">
        <path fill="url(#aa)" d="M148 85h15v11h-15z" />
      </g>
      <mask
        id="ab"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g mask="url(#ab)">
        <path
          fill="#FAA41A"
          d="M159.722 117.966c-.231-1.359-.41-2.744-.594-4.256l-.011-.087-.064-.06c-1.336-1.226-2.262-2.767-2.776-4.606l-.028-.099q-.04-.15-.076-.301l-.015-.06a11 11 0 0 1-.081-.368q-.343-1.674-.265-3.64c.124-3.116 1.034-5.891 1.333-6.803q.067-.202.097-.3l.111-.383-.39.084c-.817.176-1.61.265-2.355.265-2.519 0-4.134-1.014-5.045-1.864-1.127-1.052-1.657-2.266-1.768-2.986a5.3 5.3 0 0 1-.04-1.134c-1.745 2.112-2.747 4.46-3.063 7.024.961-1.122 2.111-1.921 3.533-2.256-1.206 1.572-2.54 5.495-2.696 10.908 1.333-3.844 3.748-8.17 5.099-8.473-.628 1.098-1.334 3.06-1.177 5.021 1.02-1.334 2.118-2.197 2.824-2.589-1.784 3.737-2.665 7.213-2.413 10.676 1.052-2.961 2.311-5.367 4.125-7.492-1.346 5.381-2.418 12.271 1.388 17.17-.488-2.471-.521-5.162-.126-7.738.775 1.523 2.125 3.139 4.473 4.347"
        />
        <path
          fill="#F68A51"
          fillRule="evenodd"
          d="M165.769 109.842c5.256-.157 10.12-5.649 3.687-13.572 0 0 5.492 10.277-3.687 13.572"
          clipRule="evenodd"
        />
        <path
          fill="#F68A51"
          d="M140.969 70.188c-1.503-.608-5.684-.941-7.776 1.325s.035 4.184.035 4.184-1.29-5.683 7.741-5.51M147.281 65.83s-2.376-4.29-7.165-4.464c-1.536-.056-3.243.296-5.126 1.377.558.227.994.453 1.848.924 0 0 3.696-3.33 10.443 2.162M156.277 61.148s-3.452-7.53-9.807-7.06c0 0 1.055.915 1.491 1.882.157.01 4.08-.157 8.316 5.178M163.024 73.7s6.904-11.375-3.295-20.79c0 0-.052 1.378-.235 2.51.531.42 7.836 5.667 3.53 18.28"
        />
        <path
          fill="#FFEB75"
          fillRule="evenodd"
          d="M172.36 87.602c-1.09.085-6.793.443-9.859-1.114 0 0 1.443 1.625 4.759 1.883 1.478.115 2.95-.176 5.104-.737.059-.016.115-.04-.004-.032"
          clipRule="evenodd"
        />
        <path
          fill="#F68A51"
          fillRule="evenodd"
          d="M151.36 93.654c1.957 1.324 7.113 2.458 9.728-3.609 0 0-3.452 5.23-9.728 3.61"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M170.555 82.462c-.721.386 5.073 1.465 5.805 1.465.733 0-3.661-2.617-5.805-1.466"
          clipRule="evenodd"
        />
        <path
          fill="#FFE639"
          fillRule="evenodd"
          d="M158.866 163.53c1.648-5.884 4.943-17.364-2.354-33.5 0 0 4.159 20.32-2.275 33.186 0 0 2.825-3.138 4.472-7.767 0 0 .785 2.668.157 8.081"
          clipRule="evenodd"
        />
        <path
          fill="#F26322"
          d="M142.39 188.87s22.255-9.545 25.288-23.981c0 0-1.203 2.563-3.164 4.76 0 0 .784-3.217.627-5.727 0 0-1.647 12.788-22.751 24.948"
        />
        <path
          fill="#96CA4F"
          fillRule="evenodd"
          d="M91.736 188.635s21.025 3.452 32.846-6.276c0 0-8.752 6.415-26.082 4.463-2.667.863-6.764 1.813-6.764 1.813M78.66 162.588s3.95 20.241 29.995 14.278c0 0-21.365 2.982-24.99-11.733-2.983-1.115-5.005-2.545-5.005-2.545M85.39 150.245s3.66 12.448 19.029 12.814c0 0-13.101-1.9-14.906-10.983-2.223-.698-4.123-1.831-4.123-1.831"
          clipRule="evenodd"
        />
        <path
          fill="#F26322"
          d="M131.721 175.925c2.354-3.217 4.707-9.022 4.707-9.022-5.884 10.591-20.084 14.592-20.084 14.592 8.081-.706 13.975-2.983 15.612-3.766-1.617 1.995-4.022 4.653-5.962 6.277 0 0 8.932-4.804 15.612-14.122-1.804 1.883-5.492 4.55-9.885 6.041M97.28 157.044s10.251 4.916 20.816 1.988c0 0-8.368 1.046-20.816-1.988M100.523 170.748s15.586 2.929 25.628-6.276c0 0-9.65 5.648-25.628 6.276"
        />
        <path
          fill="#96CA4F"
          fillRule="evenodd"
          d="M85.436 165.713s5.055 10.744 21.066 9.796c0 0-9.901.737-21.066-9.796M101.202 185.575s7.61 1.569 17.103-1.726z"
          clipRule="evenodd"
        />
        <path
          fill="#FAA41A"
          d="M139.069 122.865s-.837-10.042 3.766-20.502c0 0-1.674 15.795-3.766 20.502M138.232 98.414c-.366-3.486 4.446-14.174 9.258-18.672-.262.122-1.846 1.497-3.535 3.033-1.873 2.158-4.534 5.859-6.999 11.565-.998 2.298-1.776 4.27-2.448 6.211-2.863 8.276-4.91 17.679-6.258 28.745l-.077.631.473-.425a36 36 0 0 0 1.695-1.637c.398-3.547 1.744-16.873 6.688-26.365 0 0-3.22 9.49-4.445 24.535a48 48 0 0 1 2.981-1.731c.749-12.213 2.981-22.281 8.261-32.398-.887.702-2.822 1.644-5.594 6.508"
        />
        <path fill="#FFE639" d="M154.955 145.192s1.322-9.513-2.365-16.103z" />
        <path
          fill="#FFE639"
          fillRule="evenodd"
          d="M142.573 153.802s2.877-6.433 3.034-17.73c0 0-3.295 8.786-3.034 17.73"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="ac"
        width={32}
        height={59}
        x={121}
        y={155}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M143.689 176.824a43.1 43.1 0 0 1-9.53 9.576c-3.655 2.667-7.786 4.79-12.294 6.326 2.223 2.536 7.363 9.439 9.306 20.857 0 0 2.041-11.14-.627-20.398 0 0 18.986-11.088 21.496-37.186-1.15 4.811-2.981 12.761-8.351 20.825"
        />
      </mask>
      <g mask="url(#ac)">
        <path fill="url(#ad)" d="M121 156h32v58h-32z" />
      </g>
      <mask
        id="ae"
        width={16}
        height={23}
        x={143}
        y={188}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M157.676 189.033c-.348.099-2.68 1.545-5.559 4.182-2.587 2.369-6.244 6.292-8.974 11.531l-.045.086.028.092c.148.502 1.629 3.178 3.019 5.569 2.534-11.147 9.081-17.792 11.508-19.938l.319-1.233.104-.402z"
        />
      </mask>
      <g mask="url(#ae)">
        <path fill="url(#af)" d="M143 188h16v23h-16z" />
      </g>
      <mask
        id="ag"
        width={23}
        height={11}
        x={179}
        y={133}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="m179.231 134.154 20.772 9.47c1.359-1.143 1.572-1.235 1.646-1.394l.103-.222-20.636-8.85z"
        />
      </mask>
      <g mask="url(#ag)">
        <path fill="url(#ah)" d="M179 133h23v11h-23z" />
      </g>
      <mask
        id="ai"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g mask="url(#ai)">
        <path
          fill="#FFE639"
          fillRule="evenodd"
          d="M175.628 146.375c5.335-1.883 7.636-4.498 7.636-4.498-3.11.982-7.052 1.196-8.62 1.242.454 1.424.775 2.315.984 3.256M178.976 138.111l-5.781 1.265q.719 1.56 1.282 3.234zM176.122 149.931c7.813-1.708 11.327-5.021 11.327-5.021-3.595 1.316-9.762 2.484-11.663 2.827q.196 1.08.336 2.194"
          clipRule="evenodd"
        />
        <path
          fill="#96CA4F"
          fillRule="evenodd"
          d="M211.194 110.966c-4.289-1.36-10.356 3.504-11.82 10.304 0 0 5.308-8.029 9.859-7.637 1.539.28 2.279 2.235 2.478 3.567.555.195 1.074.39 1.604.589.603.227 1.221.459 1.914.699.107-3.175-1.138-6.46-4.035-7.522M198.85 107.671c-3.06 1.177-7.191 4.55-6.956 11.454 0 0 .511-2.502 1.647-4.55 1.615-2.911 4.708-5.413 7.58-4.09.785-.628 2.043-1.502 3.012-2.108-1.01-1.009-2.755-1.678-5.283-.706M194.457 106.52c-2.118-3.06-9.074-1.438-10.408 8.29 0 0 3.687-9.022 8.63-6.59z"
          clipRule="evenodd"
        />
        <path
          fill="#FFE95F"
          d="M158.552 75.035s3.138.863 4.943 6.198c0 0-3.845-3.452-4.943-6.198"
        />
        <path
          fill="#96CA4F"
          fillRule="evenodd"
          d="m129.28 68.91.386-.404h-3.674v1.751l2.253.003q.08-.138.17-.274a7.6 7.6 0 0 1 .865-1.077M169.665 68.506l-.038.191c-.112.55-.266 1.105-.426 1.61l19.084.132 7.545 2.133 1.493-.522-10.153-3.544z"
          clipRule="evenodd"
        />
        <path
          fill="#FFEBCF"
          fillRule="evenodd"
          d="m187.12 68.744-.002.078c0 .761.48 1.402 1.168 1.616.052.016 2.156.622 4.132 1.18 1.757.497 3.413.953 3.413.953l1.493-.52-10.133-3.538z"
          clipRule="evenodd"
        />
        <path
          fill="#DB1932"
          fillRule="evenodd"
          d="M78.137 178.593s-15.482 13.598-9.414 33.892c0 0-2.929-17.155 9.414-33.892"
          clipRule="evenodd"
        />
        <path
          fill="#FFE639"
          fillRule="evenodd"
          d="M115.167 138.896s-11.454-26.517-39.54-19.456l8.473.941s-17.73 0-32.794 25.262c0 0 11.864-15.472 28.086-20.084 10.946-3.112 24.27-1.139 35.775 13.337"
          clipRule="evenodd"
        />
        <path
          fill="#FFE639"
          fillRule="evenodd"
          d="M60.877 139.366s19.692-14.514 40.953-4.001c0 0-17.73-16.711-40.953 4.001"
          clipRule="evenodd"
        />
        <path
          fill="#FFF3B1"
          fillRule="evenodd"
          d="M112.238 134.659s-9.414-16.632-28.975-15.377l5.44 1.569s-12.972-.523-26.048 11.611c0 0 26.256-22.803 49.583 2.197"
          clipRule="evenodd"
        />
        <path
          fill="#FFF3B1"
          fillRule="evenodd"
          d="M98.614 133.482s-13.18-8.865-30.205.941c0 0 13.18-7.296 30.204-.941"
          clipRule="evenodd"
        />
        <path
          fill="#FFE639"
          fillRule="evenodd"
          d="M104.602 144.701s-12.762-12.657-30.858-1.151c-10.984 7.95-16.318 22.072-16.318 22.072s15.586-32.114 47.176-20.921"
          clipRule="evenodd"
        />
        <path
          fill="#FFF3B1"
          fillRule="evenodd"
          d="M98.953 142.086s-13.494-8.368-29.498 5.858c0 0 13.703-10.356 29.498-5.858M170.229 157.015s2.523-9.568-8.226-26.828c0 0 1.537 3.489 3.374 8.238 2.035 5.261 4.434 11.294 4.852 18.59M167.042 80.169a7.5 7.5 0 0 1 1.003-.494c-.444-1.096-2.386-5.08-7.166-5.215 0 0 4.151.872 6.163 5.709M167.025 154.978s.314-9.179-4.707-17.809c0 0 4.393 12.239.863 24.948 0 0 2.039-4.628 2.51-10.12.628.784 1.334 2.981 1.334 2.981M159.728 157.332s1.569-7.296-.314-16.397zM141.004 167.348s6.904-6.538 6.538-27.249c0 0-.785 17.102-6.538 27.249"
          clipRule="evenodd"
        />
        <path
          fill="#F26322"
          d="M106.066 141.668s-13.102-11.166-31.773-6.145c-19.928 6.197-28.322 30.204-28.322 30.204s12.004-25.027 31.068-29.42c17.207-3.112 29.027 5.361 29.027 5.361"
        />
        <path
          fill="#F26322"
          d="M90.068 146.933q.922.234 1.866.393a38 38 0 0 1 3.986-.847s-2.3-.225-5.852.454M72.494 158.409c0-.755.022-1.462.057-2.111-3.493 3.351-6.943 7.832-10 13.822 0 0 3.47-5.801 9.943-11.711M80.057 151.727q-.104-.45-.204-.947a37 37 0 0 0-4.696 3.225c.456.31.95.641 1.46.978a51 51 0 0 1 3.627-2.495 30 30 0 0 1-.187-.761M37.865 180.58s3.66-42.679 31.694-58.578c0 0-28.661 8.682-31.694 58.578"
        />
        <path
          fill="#FFE639"
          d="M140.115 93.393s3.923-9.65 9.336-14.357c0 0-2.589-.078-1.961-.55.627-.47 3.138-1.411 3.138-1.411s-2.354 7.139 3.766 7.923c0 0-3.374.785-5.022-2.981 0 0-3.53 1.883-9.257 11.376"
        />
        <path
          fill="#BA571A"
          fillRule="evenodd"
          d="M226.037 131.897c.406-1.416.805-3.244.4-3.908a.55.55 0 0 0-.483-.283c-.148 0-.306.052-.483.159l-.009.005c-4.398 2.914-7.593 11.174-7.471 10.631-1.384 4.239-.072 6.08 1.675 4.631.512-.388 2.196-1.824 4.117-5.539a33 33 0 0 0 2.254-5.696"
          clipRule="evenodd"
        />
        <path
          fill="#F68B2F"
          fillRule="evenodd"
          d="M180.589 113.519c.034-.949.15-1.708.24-2.079l.047-.195-.184-.079c-2.278-.984-4.12-1.721-4.138-1.729l-.21-.083-.095.204c-.005.011-.412.873-1.323 1.909a2008 2008 0 0 0 5.663 2.052M117.26 85.589c-4.307-1.944-8.027-3.623-8.779-3.984-1.179-.568-2.35-.92-4.536-.92-1.127 0-2.517.094-4.25.286l-.054.006-.217.139-.028.068c-.184.439-.522 1.272-.927 2.286 3.204-.18 6.954-.282 9.324.508 1.021.34 10.091 4.937 24.311 10.974a45 45 0 0 1 .856-1.968l.101-.217-.217-.1c-3.48-1.615-10.191-4.644-15.584-7.078M225.182 126.491s.552-.828-2.429-1.979c-5.725-2.439-13.404-4.386-13.491-4.413l-.14-.044-.102.106a47 47 0 0 1-2.63 2.502c5.874 2.049 10.615 3.68 13.591 4.699 1.494.511 2.196 1.099 1.804 2.589.719-.821 2.707-3.02 3.397-3.46"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="aj"
        width={31}
        height={14}
        x={180}
        y={117}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M182.427 123.78c2.407 1.36 4.29-1.045 4.29-1.045s0 3.765 2.824 4.863 5.648-1.568 5.648-1.568.314 5.177 5.178 4.236c2.222-.43 4.148-3.039 6.12-5.335a83 83 0 0 1 3.88-4.48c-.68-.219-1.085-.345-1.104-.352l-.142-.044-.101.106c-1.634 1.701-4.866 4.615-6.938 5.765-1.039.578-1.983.871-2.805.871-1.567 0-2.707-1.075-3.39-3.195l-.11-.341-.272.234c-.973.836-1.948 1.26-2.899 1.26-1.96 0-3.599-1.82-4.616-5.124l-.144-.469-.279.403c-.863 1.245-1.784 1.875-2.739 1.875-1.091 0-1.969-.817-2.396-1.305-.729-.824-1.19-1.84-1.469-2.89q-.05-.181-.101-.179c-.336 0-.619 5.48 1.565 6.714"
        />
      </mask>
      <g mask="url(#aj)">
        <path fill="url(#ak)" d="M180 117h31v15h-31z" />
      </g>
      <mask
        id="al"
        width={13}
        height={13}
        x={163}
        y={111}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path
          fill="#fff"
          d="M166.503 115.123c-.765 0-1.565-.064-2.379-.191l-.263-.041-.011.266c-.141 3.187 1.29 6.831 1.351 6.984l.037.093 1.913.802s-1.382-3.047-1.303-5.48c1.491 0 6.124-1.547 9.647-6.397-1.727 1.83-4.234 3.809-8.992 3.964"
        />
      </mask>
      <g mask="url(#al)">
        <path fill="url(#am)" d="M163 111h13v13h-13z" />
      </g>
      <mask
        id="an"
        width={504}
        height={291}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </mask>
      <g mask="url(#an)">
        <path
          fill="#BA571A"
          fillRule="evenodd"
          d="M165.796 121.688s7.778 2.976 17.678 7.008c14.121 5.752 32.846 13.285 32.846 13.285s-8.342-5.831-50.785-22.071zM96.639 90.98s2.458 4.125 5.976 5.498c9.892 3.392 23.349 8.142 25.924 9.051q.196-.693.414-1.429c-3.744-1.136-23.791-8.04-26.044-8.962-2.53-1.033-6.27-4.158-6.27-4.158"
          clipRule="evenodd"
        />
        <path
          fill="#F26322"
          d="M132.043 213.705s6.241-13.668 13.25-22.037c0 0-1.308-.122-2.301-.523-.157.244-8.735 14.418-10.949 22.56M150.475 214.092c.606-2.465 4.077-16.509 5.697-21.273 0 0-1.988 2.406-2.511 3.347 0 0-.946 5.571-3.173 17.729-.034.188-.072.438-.013.197"
        />
        <path
          fill="#D1DE9B"
          fillRule="evenodd"
          d="M214.097 115.203s-1.961-7.688-10.042-1.177c0 0 6.59-4.236 10.042 1.177M203.035 108.142s-2.746-1.648-6.669 1.648zM192.993 106.18s-3.295-1.255-5.806 1.883z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M97.871 40.476c-1.828-1.37-3.622-2.34-4.98-3.032-2.815-1.433-5.003-2.131-5.623-2.283a1.8 1.8 0 0 0-.558-.102c-.568 0-.864.372-1.215.855q.105-.016.223-.013c.174.005.364.043.58.117.645.17 2.915.93 5.82 2.443 1.403.73 3.254 1.752 5.13 3.174.58.389 1.064 1.06.694 1.788-.099.239.538-.901.64-1.178.333-.74-.146-1.397-.71-1.77M73.98 65.071c-1.283 2.448-5.91 15.43-6.12 22.542 0 0 9.18-8.734 6.12-22.542"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M86.924 35.913c-.575.628 3.243 3.609 5.753 2.249z"
          clipRule="evenodd"
        />
        <path
          fill="#00AA4F"
          fillRule="evenodd"
          d="m192.825 70.48-.079.225c-.253.403-.396.86-.396 1.345 0 .487.143.945.396 1.347l.106.215 4.471-1.562z"
          clipRule="evenodd"
        />
        <path
          fill="#96CA4F"
          fillRule="evenodd"
          d="m197.323 72.05-4.531-1.582-.047.237a2.5 2.5 0 0 0-.355.905l3.44.962z"
          clipRule="evenodd"
        />
        <path
          fill="#00402F"
          fillRule="evenodd"
          d="M156.988 78.721c-.077.345-.366.602-.712.602-.404 0-.732-.35-.732-.784 0-.373.243-.685.569-.764a2.2 2.2 0 0 0-1.216-.37c-1.395 0-2.526 1.344-2.526 3.002 0 1.66 1.131 3.004 2.526 3.004 1.396 0 2.527-1.345 2.527-3.004 0-.625-.161-1.205-.436-1.686"
          clipRule="evenodd"
        />
        <path
          fill="#00402F"
          fillRule="evenodd"
          d="M156.814 60.589c.724-.458 1.432-3.101 1.667-4.27.381-1.9.342-3.366.246-5.308.664.063 9.405 6.939 7.053 17.353-.593 2.989-1.135 4.056-2.096 6.214 1.956.527 3.983 2.8 4.727 4.71-2.162.698-3.522 2.337-5.37 3.418-.761.42-1.874.906-3.161.71-.487-.075-.771-.042-.744.51 0 0 .418 3.104 2.724 5.722-2.097 6.69-8.525 6.802-11.307 3.952-.706-.723-2.338-2.897-.716-6.97-.284.338-1.411 1.623-1.925 2.98-.373.985-.589 2.07-.457 3.068.418 2.58 3.975 6.207 9.558 4.64-.283.974-4.084 10.946 1.879 16.421.697 5.718 1.307 9.728 5.143 17.505l4.376 8.593c4.24 8.216 4.887 18.47.913 26.631-.675 1.387-8.131 16.466-26.589 23.597 1.721.767 4.859.872 4.859.872s-9.205 8.996-15.755 25.553c-.318.718-1.123.922-1.295.075-2.828-13.908-10.008-22.968-10.042-23.144 21.417-6.59 30.337-24.533 31.773-38.285 1.53-16.333-3.123-23.823-4.406-25.547-.2-.268-.237.1-.111.945.42 2.832 1.34 9.567 1.379 14.56-.078 23.065-15.165 45.836-48.248 45.346-7.12-.312-13.887-1.679-13.887-1.679s16.031-2.322 21.422-11.371c-8.529 4.062-28.404 2.528-31.333-17.207 15.447 9.972 25.144 4.145 25.558 3.556-1.754-.157-16.213-1.848-18.445-15.132 4.463 2.545 8.891 3.975 16.841 2.754 23.223-6.032 36.276-26.974 36.078-27.26-.094-.135-1.624-.442-3.336.464-1.917 1.015-2.86 2.563-5.3 4.76 1.499-12.309 3.761-21.51 6.246-28.696.751-2.167 1.573-4.193 2.442-6.194 4.945-11.45 10.667-14.938 10.667-14.938l-1.9-.34c.313-.418 1.563-2.092 5.418-3.6-2.432.132-5.929 1.317-8.008 1.755-3.917 1.07-8.808.665-11.1-1.684-2.266-2.267.733-8.16 8.509-6.365-1.396-4.165-6.786-6.037-7.114-6.43.281-.378 7.88-5.93 13.942 2.403.319-.441 2.725-7.147-3.145-12.056 2.64-.55 8.938.097 12.37 7.409m9.051 22.884c2.55-1.65 4.062-1.953 6.73-1.691.725.065 5.23.959 7.155 5.285-1.646-.107-5.621-.84-8.933-.91-3.439-.047-6.625-.313-8.474-1.115 1.779-.453 2.425-.862 3.522-1.57m-1.746 4.957c-1.671-.773-2.034-2.35-2.02-2.342 0 0 .755.439 2.232.872 3.046.78 6.311.174 10.858.703-.022.39-5.977 3.446-11.07.767m-4.319 13.579c0-3.126.862-5.981 2.062-8.333.216-.423 1.856-3.153 2.2-2.798-.149.615-1.3 4.903.456 8.177.185-.656.476-4.877 3.158-7.427.595 1.957 1.641 3.874 3.908 6.455 2.789 3.138 2.457 8.422-1.142 11.156-2.228 1.692-5.844 2.05-8.203.002-1.545-1.342-2.439-3.842-2.439-7.232m26.759 15.155c-1.673 3.478-5.578-2.946-.401-9.876 2.755-3.461 6.521-3.33 8.717-1.709 0 0-2.65.942-5.265 5.091-1.039 1.609-1.917 3.452-3.051 6.494m6.434-5.622c2.719-3.504 7.688-6.695 11.715-3.766-7.793 4.446-9.989 9.99-10.931 12.657-.784 2.563-5.711-1.597-.784-8.891m-23.505 2.89.034.036c-.002-.002-.044-.025-.034-.036m-5.401.736c9.17 1.43 12.378-5.509 12.378-5.509s1.831.732 4.132 1.726c-.331 1.377-.75 6.189 1.656 8.909 1.052 1.201 3.26 2.65 5.509-.593 1.674 5.439 4.917 6.538 7.898 3.975 1.517 4.707 4.893 3.373 6.538 2.458 2.089-1.159 5.335-4.079 6.994-5.807 0 0 8.26 2.212 14.084 4.761.691.303 2.145 1.115 1.455 1.591-3.375 2.827-7.34 9.923-7.34 14.792.069 1.046 2.278-9.477 8.203-13.402 1.797-1.082.188 5.14-2.022 9.415-1.544 2.985-3.173 4.812-4.184 5.579s-2.344.627-3.758.028c-1.097-.466-7.645-3.27-9.942-4.261-4.467-1.928-9.04-3.663-13.532-5.531l-13.086-5.52-13.648-5.726s-1.475-3.712-1.335-6.885m44.204-4.986c2.821-.821 7.575 1.151 7.714 8.316-2.562-.837-3.974-1.569-7.06-2.406-.914.738-7.532 6.695-9.205 7.322-2.825 1.203-.759-10.251 8.551-13.232m-37.267 24.197s-3.102-5.124-3.751-6.768c1.87.842 8.587 3.632 8.587 3.632-.167.297-4.391 2.958-4.836 3.136m10.114-.952 20.294 8.703c-.201.432-7.882 8.638-24.724 12.542-.079-.787.123-8.454-3.628-16.091zM71.468 119.91c8.743-3.924 20.062-4.253 31.068 2.197 9.284 5.282 13.102 13.808 14.128 17.656-.271.442-20.082 16.201-37.12 1.219-1.686 7.381 1.557 15.749 2.638 17.004-1.953-.662-9.38-5.893-9.38-5.893s-1.15 5.335-.124 11.836c-.05.25-21.607 14.429-20.139 46.953-7.742-12.994-8.802-25.53-4.633-39.611-1.118.818-9.519 14.226-9.257 33.421-6.564-23.824 3.19-71.915 32.82-84.782m4.315 51.936c-8.239 7.293-11.663 16.824-12.29 18.463-.454.383-2.41.96-3.479 1.857 1.906-13.066 13.607-23.247 14.314-23.498.322.929 1.27 2.8 1.455 3.178m-5.13 47.442s-5.73-8.756-4.024-22.006c.66-5.524 5.302-16.649 12.136-21.042 1.883 2.118 4.942 4.314 9.414 6.197-3.016 1.343-18.358 8.866-17.527 36.851m72.701-14.431c5.182-9.946 13.819-15.432 14.387-15.594 0 0-3.609 13.965-5.544 21.444-.347 1.302-.733 3.813-1.151 4.393-.362.502-.784.785-1.412.419s-6.017-9.77-6.28-10.662m-58.445-6.095c.62-.399 4.734-2.909 10.362-3.366-.816.823-6.569 7.884-7.57 18.081-3.445-4.915-2.974-13.858-2.792-14.715m70.364-123.577c5.711.547 3.469 6.913 3.026 6.893.786-4.513-1.856-5.613-3.173-5.613-3.243-.105-3.801 3.382-3.905 4.81-.349-.487-.429-2.388.383-3.974.582-1.136 1.672-2.266 3.669-2.116M75.731 60.007c7.427-3.121 6.695-11.437 6.015-15.464 1.552.366 7.48 2.3 11.768 6.276-2.903 1.96-5.426 4.03-6.355 6.407-1.027 2.619-1.098 5.884 0 9.1-6.084-3.922-11.428-6.32-11.428-6.32m6.486-17.783c.837-2.092 2.716-5.152 3.242-5.858.585-.783.81-1.285 1.744-.976.657.159 2.83.866 5.58 2.266 1.525.777 3.228 1.723 4.951 3.015.481.315.915.859.627 1.483-.206.566-1.656 4.42-3.243 6.695-5.23-4.114-12.9-6.625-12.9-6.625m-4.05 70.433c-.433.065-1.694.322-2.122.402-2.305-3.287-8.839-12.553-10.622-21.814-.552-3.635.098-8.131 1.203-12.462 1.851-7.24 4.942-13.953 5.854-15.561.814.17 4.4 1.78 8.725 4.35 2.065 1.228 6.23 3.96 9.642 6.155 1.887 1.215 3.571 2.26 4.42 2.823.548.342.757.55.705.76-1.275 4.975-4.969 12.858-5.492 13.346-.244.279-1.307-.087-4.654-.715-8.526-1.621-13.573-1.883-14.732-.017-.702 1.354.267 5.378 1.733 9.61 1.383 3.998 3.323 8.742 5.34 13.123m48.907-1.82c-.388 1.798-2.562 10.119-4.306 23.09-.236.474-1.864 2.146-2.281 2.588-3.294-9.222-8.813-14.881-14.944-18.435-10.192-5.911-21.336-5.888-21.336-5.888-3.114-7.784-4.859-13.785-5.389-16.48-.177-.897-.132-1.77 1.22-1.562 2.318.237 7.004 1.276 11.201 2.146.82.2 1.543-.654 1.543-.654s3.417 4.603 6.361 6.399c1.763.923 8.144 1.76 27.931 8.796m5.67-17.954c-1.767 3.79-3.572 9.429-4.667 13.416-4.916-1.907-23.867-8.256-26.543-9.262-1.465-.454-4.596-3.802-5.998-5.544.698-1.744 4.108-10.286 4.108-10.286 5.292-.587 7.035-.205 8.733.612s18.11 8.162 24.367 11.064m-15.749-24.138h1.123v6.614h-1.123a3.316 3.316 0 0 1-3.306-3.308 3.314 3.314 0 0 1 3.306-3.306m2.836-.522h4.686v7.566h-4.686zm9.277.522c-.31.322-.601.672-.892 1.109-1.204 1.81-1.095 3.76-.306 5.505h-1.681v-6.614zm42.197 6.614c-.942-1.893-2.638-2.937-2.638-2.937s.824-1.85 1.193-3.677h17.27l9.471 3.306-9.471 3.308zm-30.772 133.099c.523.18 7.369 10.743 7.921 12.38s1.789 5.972 1.853 8.51c-1.802.001-3.563 1.36-4.352 2.777-2.485-.003-3.814.449-5.357 1.505-.571.389-1.399 1.032-1.697 1.734-.588 1.382 1.708 1.586 2.95 1.794.787.132.56.264 1.096.618 2.318 1.529 5.58.497 7.674-.835l.355.168c.109.036.287.081.413.117.928.26 1.555.345 2.595.344l.159.641c-.248.411-.491.662-.724 1.191-.702 1.59-.6 3.256.337 4.532.929 1.265 2.839 2.548 5.193 2.189.504.326 1.108.674 1.651 1.015.53.333 1.165.702 1.663.897 1.672.657 2.052-1.588 2.131-2.773.327-4.88-2.703-6.228-3.309-6.944 1.102.173 2.416.819 4.271.968.454.037 2.088.098 2.324.234 3.186 1.845 6.093 2.959 9.878 1.062 4.085-2.047 8.42.588 7.929-1.775-.336-1.613-3.726-4.655-5.286-4.974.276-.886-.861-1.863-1.496-2.344-.828-.625-1.453-1.063-2.476-1.584-1.639-.834-4.274-1.662-6.663-1.148-1.172.251-1.923.75-2.793 1.259-3.468 2.029-4.036-1.458-9.532-1.415-.088-.466-.305-.939-.495-1.427-.185-.477-.303-.882-.462-1.359-2.777-8.286-1.154-11.089.151-16.132 1.306-5.043 7.373-24.343 8.001-26.226.784-2.615.679-2.667 4.027-7.008 2.923-3.735 6.572-8.804 7.897-16.58 18.882-3.504 30.211-15.909 30.211-15.909s1.122.513 3.925 1.683c2.569 1.072 6.432 3.145 8.857 1.708 5.002-2.73 9.344-11.792 10.042-17.922.392-4.106-.694-5.859-2.746-6.773-2.603-1.121-7.558-3.112-7.558-3.112s1.831-13.651-11.202-12.966c-2.239-3.614-6.702-3.405-9.736-2.393-4.293-3.144-8.216-3.022-11.053-1.639-2.324 1.133-3.893 3.155-4.568 4.568a105 105 0 0 1-4.875-1.626c.845-5.496-1.946-8.661-3.877-10.997-1.429-1.813-1.769-3.134-1.769-3.134s1.225-.277 2.467-.701c1.169-.4 2.013-.902 2.89-1.02 3.104-.428 4.89.623 5.976 1.014.85-3.156-.719-6.62-2.898-8.836-1.056-1.073-1.88-1.746-3.58-2.572-1.148-.557-1.808-.767-2.399-.886h12.646q.122 0 .242-.02l.563-.104q.103-.019.211-.057l13.52-4.92a1.281 1.281 0 0 0 0-2.409s-14.107-5.1-14.187-5.1h-17.193c.722-16.723-15.754-20.247-15.754-20.247s.681 4.187.481 6.385c0 0-1.699-1.372-4.298-2.128-3.755-1.093-9.294-1.37-13.502 1.69 2.135 1.483 3.983 3.575 4.828 5.619-9.458-2.672-14.096 6.017-13.991 6.708 1.246.51 2.81 1.394 4.044 1.974h-4.815a1.28 1.28 0 0 0-1.033-.521h-8.111c-.425 0-.799.205-1.034.52h-.09c-.846 0-1.66.173-2.406.483a6.4 6.4 0 0 0-2.048 1.368 6.4 6.4 0 0 0-1.367 2.047 6.3 6.3 0 0 0-.483 2.407c0 .848.173 1.662.483 2.409a6.3 6.3 0 0 0 1.367 2.045 6.4 6.4 0 0 0 2.048 1.369c.746.31 1.56.482 2.406.482h.166c.235.264.576.429.958.429h8.111c.382 0 .724-.165.96-.43l2.344.097c1.673 1.813 4.742 4.045 10.254 3.352-1.572 1.809-4.003 5.909-4.599 6.963-18.661-7.77-24.604-11.722-25.939-11.995-2.59-.552-7.043-.535-8.357-.517-.091-1.36-.563-1.811-1.59-2.371-4.448-2.44-7.043-3.87-8.578-6.59-1.702-3.138-2.849-11.54 5.3-14.07.616-.28 1.031-.503 1.33-.898.351-.534 2.951-3.807 5.182-9.771.146-.393.234-.78.169-1.22-.061-.427-.266-.871-.698-1.366-1.81-2.07-8.022-5.887-14.56-8.136-1.813-.627-2.894-.488-4.045 1.116-1.604 2.04-4.428 7.183-4.95 8.96-.21 1.012.2 2.125.313 3.68.837 7.183-.105 8.682-3.344 11.046-3.804 2.5-4.633 1.64-5.478 2.64-.706 1.077-5.397 9.11-7.65 17.996-1.23 4.853-1.838 10.114-.888 14.964.63 3.216 3.552 10.677 11.554 21.589-9.447 3.582-15.488 8.623-20.319 13.853-5.6 6.063-9.419 12.506-12.579 19.221-8.578 19.53-9.996 42.01-5.466 58.683 2.348 8.638 7.532 16.632 11.62 20.276 0 0-5.056-9.188-3.587-24.768 4.363 18.143 18.013 26.626 18.013 26.626s-5.255-16.093.864-25.194c.127 23.908 15.9 30.623 15.9 30.623s-5.126-16.475 2.057-31.642c-.488 16.527 13.32 25 13.32 25s-3.732-19.385 10.669-30.231c2.197-.104 9.624.21 16.61 6.881 6.093 6.036 6.643 18.315 6.639 26.41-.002 2.798-.342 5.24-1.196 7.241-2.233.115-3.892 1.664-5.187 3.146-.388.445-.843 1.082-1.093 1.573-1.967-.06-3.144-.113-4.597.636-1.041.537-2.188 1.525-2.733 2.607-.31.697-.005.758-.895 1.778-1.02 1.132-3.219 4.774-1.854 5.378.553.245 1.532-.254 2.42-.544 3.858-1.265 2.693-.116 5.19-.474 2.283-.327 4.2-1.781 5.517-3.554.914-1.228.895-.809 2.953-1.535.396-.14.666-.294 1.154-.35.136.23.26.423.415.65-.315.532-.67.918-1.008 1.646-1.386 2.979-.392 6.672 2.785 7.592 1.119.317.814.31 1.825 1.32.249.249 2.515 2.652 3.516 1.884 1.166-.897 1.612-3.315 1.679-3.446.137-.267.577-.323.904-1.655 1.062-4.329-2.358-6.573-2.639-7.339.352.044.634.174.991.286l4.261 1.289c.461.235 1.417 2.387 4.208 3.484 3.147 1.236 3.142-.33 4.875-.072.389.058.687.082 1.045.137 2.679.414 5.463 1.824 5.096-.398-.232-1.398-1.812-3.524-2.778-4.488l-1.206-1.067c-.208-.882-.239-1.352-.855-2.21-1.486-2.07-3.692-3.151-6.67-2.937-2.94.21-3.036-.135-4.811-1.389-1.833-1.296-2.628-1.6-4.801-2.102-.061-.504-.863-4.158.223-11.684.666-5.105 7.099-16.507 7.099-16.507"
          clipRule="evenodd"
        />
        <path
          fill="#DB1932"
          fillRule="evenodd"
          d="M154.897 81.638c-.818 0-1.499-.694-1.649-1.614a2.3 2.3 0 0 0-.032.384c0 1.103.753 1.997 1.681 1.997s1.68-.894 1.68-1.997q0-.198-.031-.384c-.15.92-.831 1.614-1.649 1.614"
          clipRule="evenodd"
        />
        <path
          fill="#045041"
          d="M155.666 235.092s3.278 1.242 4.298 3.831c0 0 2.824 2.118 2.903 5.335.078 3.216-1.805.078-1.805.078s-5.008.31-3.687-4.583c.233-2.952-1.709-4.661-1.709-4.661"
        />
        <path
          fill="#004636"
          d="M150.942 231s-2.589-.392-3.687 2.197c0 0-4.864-.863-6.59 2.589 0 0 3.922-1.569 6.903-1.648 2.982-.078 3.374-3.138 3.374-3.138"
        />
        <path
          fill="#045041"
          d="M178.115 236.646s-.311-1.01.466-2.175c.385-.516-3.012-4.517-8.165-4.003-1.055.131-2.046.646-3.224 1.181-1.318.606-2.549.681-3.276.364-1.788-.779-4.327-2.472-8.016-1.814 0 0-2.714-9.366-3.185-12.739-.466 6.913 2.464 14.717 2.464 14.717s2.151-.304 4.837.507c2.256.682 3.185 2.176 4.972 2.098 1.786-.078 8.614-3.588 12.489 3.13 3.923-.549 5.465.628 5.945.227.2-.174-.746-1.201-1.734-1.959-1.228-.942-2.408-1.32-3.573.466M151.984 249.401c-.567-1.06-1.739-2.738-3.697-3.357.233-2.097-1.088-5.515-7.535-4.272-3.651.233-3.806-3.573-9.088-3.573 0 0-1.398-11.108 1.631-18.409 0 0-3.797 3.782-3.728 19.963 0 0 3.107-.777 6.369 2.019s2.253 1.942 5.049 2.175 4.738 1.087 5.204 3.806c1.587.254 2.862.663 4.801 1.737.434.24 1.281.448.994-.089M133.451 256.997c.544-.078 1.087-1.942.777-3.029 1.398-1.709 1.009-4.583-1.476-7.224-3.263-3.107-3.263-5.36-3.263-5.36s-1.087 3.029.466 4.894c3.693 4.352 2.088 6.992 2.01 7.769s.942 3.028 1.486 2.95"
        />
        <path
          fill="#004636"
          d="M125.889 238.426s-3.928-.121-5.858 4.341c-2.62.088-5.91-.157-7.087 3.433 0 0-2.33 2.718-2.175 3.262s3.029-1.631 3.884-2.486c3.573 1.632 6.012-.547 6.633-3.11.419-2.249 2.273-3.731 4.603-5.44"
        />
        <path
          fill="#437064"
          d="M177.668 234.295s-4.916-6.067-11.193-1.36c0 0 5.231-2.092 11.193 1.36M162.5 232.673s-2.981-3.138-6.276-1.569c3.007.183 6.276 1.569 6.276 1.569M162.291 244.912s.418-3.243-2.144-4.969c0 0 1.83 3.557 2.144 4.969M147.751 245.853s.209-5.021-6.59-3.557c0 0 5.962-.784 5.858 4.08zM132.688 247.632s3.138 2.667 1.308 5.91c0 0 .313-3.243-1.308-5.91"
        />
        <path
          fill="#2E6255"
          d="M119.874 243.552s-5.178-1.046-6.224 2.615c0 0 2.406-2.406 6.224-2.615"
        />
        <path fill="#437064" d="M137.134 241.199s-1.883-2.197-4.786-2.275z" />
        <path fill="#2E6255" d="M150.244 231.453s-1.778 0-2.441 1.639z" />
      </g>
    </g>
    <defs>
      <pattern
        id="d"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#ao" transform="scale(.03333 .04545)" />
      </pattern>
      <pattern
        id="g"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#ap" transform="scale(.0102 .00595)" />
      </pattern>
      <pattern
        id="j"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aq" transform="scale(.0137 .125)" />
      </pattern>
      <pattern
        id="l"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#ar" transform="scale(.16667 .1)" />
      </pattern>
      <pattern
        id="o"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#as" transform="scale(.16667 .125)" />
      </pattern>
      <pattern
        id="r"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#at" transform="scale(.07692 .05)" />
      </pattern>
      <pattern
        id="t"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#au" transform="scale(.0625 .03571)" />
      </pattern>
      <pattern
        id="v"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#av" transform="scale(.04167 .02174)" />
      </pattern>
      <pattern
        id="x"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aw" transform="scale(.05556 .04)" />
      </pattern>
      <pattern
        id="z"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#ax" transform="scale(.01235 .01042)" />
      </pattern>
      <pattern
        id="C"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#ay" transform="scale(.00758 .01563)" />
      </pattern>
      <pattern
        id="F"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#az" transform="scale(.06667 .04762)" />
      </pattern>
      <pattern
        id="H"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aA" transform="scale(.0909 .125)" />
      </pattern>
      <pattern
        id="J"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aB" transform="scale(.02 .01429)" />
      </pattern>
      <pattern
        id="M"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aC" transform="scale(.01266 .01087)" />
      </pattern>
      <pattern
        id="O"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aD" transform="scale(.0625 .0303)" />
      </pattern>
      <pattern
        id="R"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aE" transform="scale(.02703 .03448)" />
      </pattern>
      <pattern
        id="T"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aF" transform="scale(.05882 .04545)" />
      </pattern>
      <pattern
        id="V"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aG" transform="scale(.0625 .07143)" />
      </pattern>
      <pattern
        id="Y"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aH" transform="scale(.05263 .02)" />
      </pattern>
      <pattern
        id="aa"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aI" transform="scale(.06667 .0909)" />
      </pattern>
      <pattern
        id="ad"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aJ" transform="scale(.03125 .01724)" />
      </pattern>
      <pattern
        id="af"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aK" transform="scale(.0625 .04348)" />
      </pattern>
      <pattern
        id="ah"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aL" transform="scale(.04348 .0909)" />
      </pattern>
      <pattern
        id="ak"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aM" transform="scale(.03226 .06667)" />
      </pattern>
      <pattern
        id="am"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#aN" transform="scale(.07692)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA40lEQVR4nOWVuQrCUBREUyhYiIVgIaIoioqiYnD9/0JRBEVccMXtJ4x548tLwCRFiDHeFCluPczhzoz0HEXg9V7LDNi+CnZuAbcOcO8Bj4FxQ8eTvIoq0zjUdR7sUAMubS7cNQk7i/4kLBzPU1C3ZbBTE7hqjvv/dxw86mM9JKiVcZSjzgrUpI6VWYKjLthQu3PrC2q2q+jPFQLUSRNqmYtSol6kA0A9iUFd5egrU6DeFHmGGwGg1irTgjoc61QyKlPWn8slbl9yTLtOojLt60SY4886UaHmObZWJilqU2V+ifoNm7iK9jmIFtAAAAAASUVORK5CYII="
        id="ao"
        width={30}
        height={22}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAACoCAYAAAAb1jvcAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAE6UlEQVR4nO3bW2vUQBjG8VwoShGxHihSlEo9UVGpKOr3v9DallbFWlmt5y/RPcRu1mxnd5M0p8n8J3kunvuFH+8zmTfZ4PjNuVBxn8D1D1AEgYogIBEEJIKARBCQCAISQUAiCEgEAYkgIBEEJIKARBCQCAISQUAiCEgEAYkgIBEEJIKARBCQCAISQUAiCEgEAYkgIBEEJIKARBCQCAISQUAiCEgEAYkgIBEEJIKARBCQCAISQUAiCEgEAYkgIBEEJIKARBCQCAISQUAiCEgEAYkgIBEEJIKARBCQCAISQRDy9rwgXAPEEQQAQRAQBEEAAAQBQhAEAEAQEABBCKLlKQggCAiAIEAIgoAgCAIAIAgQgiAAAP3/EYQjhL6ZLUE4QTieQ+hvXRCEMwADQRCuEAwAQUAABNE0giDcIOQF6L+7GEUQjqooBhCEwxqaR+hvdxUCMgUThKUo3YOwPgkpCCmT0D0IWBXFAJNc6ggEqooWEdoPAa0hEyDKTlsh0DW0NAPQ37kcRRCOqmgGYrdtEOhJSACIEK5EaQ8EFiC5isZTECO0A8LDGjIB+rtXw8HesucQHleRieA3BBYgTxWdAgz2roeD/WseQrSkimKAwf6NKP5AoGuo3BTECIP3K55AoKYgBWA7/YkobQoG+ysRwuDDTQ8grE+CmyqaIuAh0FWU9kSUVUXJAFE+rkIhOlBFMcAkt2AQrmqo7BSkAixn1pAJMPx0OwoHomNVZCIMD9YgEKgqykKor4pMhOHBHccQHa6iGGD4eT0cHq47hMDWUL5taerl7KwpiABmEYaHdx1AeFNDJe8FOWrIBBge3g+HX+41DOHlgVxnFa0lIox6DxqEwAJU2RPleyKaTkICwKj3MBx93WgAou1VVOBAnkU4AehtRAijb48sQ3RqClaTp8BEMKfAQBgdPbYIQZkEYhX1TgFGR0/C0fenFiAoAPAqMhHCn5s1QtgEqDwF9lcUWU9E8YG8APBjjPAsDH89rwkCNQXNbEszz4IThLSzYIwwAdicIoS/X1SEsD4FTdVQ9RXF4hSk15AJEP55eZJXFSBURZWqyEQI/74uCdHVKsqYhKJVZCIUh3BVRcBtae4qypgCM/khsDVU/VOWUgdyxuXsFCBhCuYA8kOgasjNS5sy94I8U5AfwssD2Y8qyg+BBQCsKFIBNgsDpEN4U0XNvripu4qyIbBTUOZeUHVbmrComyI8yTiQiwEsQmARAFWUsC2tWkWLEG2vIkvb0qpVZBXC2RMRYEVRNbVB+PwpSx0rCucQxE/c6TVUO0SXt6UYiNq3pR2rosoQrd+WNgxQGIJxL+BsS91DuKyiwjfklMvZGCHpcjZGaHAKCkFYPZAJVdTggVwKglFF/qworEC0+cWNiyeiwhDsbWnKFJx1FljallqDUBUBIFDbUuiLG+sQuG1piX/bEFYU1SF0OUMk0LaUkXwQ2pY2DKFtKQACXUW8bWn9EE7uBbY+ZWEfyAUhXG5LMxBg21J7EL5sS1tSRYsQWlEgEvj4x7+2IRgQDX3QVeXN2RihhQDJEC5X1h2rogQI1ra0K1W0COFkW8p+f+wIQttSQgLrT0VFb8gdmoI5CG1LCQlURYwEenHDSKBPWRgJqldRN7elFiC0LSUk0LaUkUDbUkaCtn7m7lsCbUsZCVRFjATaljLyD5eKvpsyXIWUAAAAAElFTkSuQmCC"
        id="ap"
        width={98}
        height={168}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAAAICAYAAAC1d9IVAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQ0lEQVR4nO3EMQ2AMABE0e+IsJN06MJA2FFREbVQCSyoPKqgZ+CG96BsCoO6KwyeQ2HQqsKgnwqDcSkM3lth8M1i6QesPOjLqPcTgQAAAABJRU5ErkJggg=="
        id="aq"
        width={73}
        height={8}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAPklEQVR4nGOobmj4jw0zkC7R1Nb2Hxtm6Jkw4T82zDB15sz/2DDDvIWL/mPDDEtXrPyPDTOsWL3mPzaMUwIAO4ijb+//LUQAAAAASUVORK5CYII="
        id="ar"
        width={6}
        height={10}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAALElEQVR4nGP4Uuv7HxtmoKZEc9h/bJjh29SC/9gww4/Frf+xYYYfK7r/Y8MASuyKExNlrGAAAAAASUVORK5CYII="
        id="as"
        width={6}
        height={8}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAUCAYAAABWMrcvAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAU0lEQVR4nGNgsNf/TzIe5JoYHQ3+k4oZNJwM/pOKGZyBBKmYIcpR/z+pmCHPVu8/qZih2Uz3P6mYYaqu9n9SMcMSea3/pGKGtUJa/0nFo5rorgkA7Z/H4Kjb5VMAAAAASUVORK5CYII="
        id="at"
        width={13}
        height={20}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAYAAABoMT8aAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABbUlEQVR4nK2VyU6DYBSFeQ1nq6UUylQbZ+tUY6y6cNpYd752tYO2oDUh8QmOF/8fA8GGC7rorjnh++45oEyuqvDPDIz2TQw3bPQtB8+rLrrzdXRnsn/Kx62Gtwsd3kkNr3sWhusUYlDICoXMcQPOdYyPKWDHwmDNQU938bRMf5jlBNxo8NuEcGjiZcvGwKWACgUscRHuNLxfSoSmJTyYfA9KcK8iFOmdGiKgYaMXOigxHQQdFSGG8EAY24RRJwyNMBZzBMQ99G16ApUCWAgdgZDogpnjjMFDGalTNsJTOuKUbAdtCjiSDtycDibXEuGAAjalgzL3jBEC1XncIoRdcUpundNnjOpc5dV5uoMK10EMwWvFFlnj1Vn5fCzhL10QAXIPPu1h1BRPEO6B1YPoCaI6f3sIZ+1IDwtchN+68C8Oss4YRyhS55SDn1ebIyfNchBfpKxztMisN1MSYVqdCztg1DmJUGCRaQc5PzBfJn3j53HFPg0AAAAASUVORK5CYII="
        id="au"
        width={16}
        height={28}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAuCAYAAAAyVNlIAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACmElEQVR4nLXU6W9MURgG8NcHia/MWhoqlDrn3jszVFHVdioiRIgQIUKIEEIIIYQgBEEQW6yx79Re+652te/8MY9nxkxNtGa958PzZebm/eV9zrlX2kbDkFhqQ5AaA/FxeDumTRwJuw+U1YVRwhiDKjg8xBiDohxaxRiDhnKYUWR0XQgjOMwYNDEawjjGGDSd938KYwyaVePAKLKgysHcagfGoKWVNhYNtDF/kIM5hGbyx2lEJhOYwIwlMoqDhjNDmFqmkilnbKaUKWbaE2j1s7Oqn43lA2wsIbKQ28wjNJvQDP45lQ9OIjKeGZPvNuvLLaypsLCyv41lhBYTcrW2bSGNzRELpiDZZWlsdzS2ENnYx8K6vhZWs7YVhNw4HznQU2NvL41UaAO3WcttcjmfkRw2jBnMVKdsI0e6aRzsobGPyG6tscPW2BrW2NTbndrkVEeFE50VjnbVOFSqsb9MY4/S2EkoeT7pNsoEyVm/wukiIsUKx0oUDnfXaK22fM9H6j0K53wKZ4IKJzspHO+i4GZtconAhQ4K55NQQCFTbblAcsWjcZnDL8YQpt6r4GZtct1rocGrYQqSWwRuMNeINHj+QC1qK+B85J7Pxl0mKyiL8/n3WssDDk8it30WbhJxszZp9Dt4xJiC5BmHP2EeMw/9djN0x6Xa5EUghOcBB08JNKZA91O2SYWuJrfxJLbJAMlrAq+YGJTcxs3a5F0wjDcc3pQCubJR4mrLRwLvmbcJKJeNsjkf+cTBhSCZapOvwQg+c7ApSL4XRfCNyQfK5lrLLw7/yRQCpdsoDphEmgFTUAvAbei/QD7Qy/hL+heKvaQZgSTyIwHFkC8JKIZ8YNJ9DbICCqktJyAXqCkB5QXkUlveQLbb/AZShfc9l3xSsAAAAABJRU5ErkJggg=="
        id="av"
        width={24}
        height={46}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAZCAYAAAA8CX6UAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA3ElEQVR4nK3MPwsBcRwH4G95B+78HS3K3fndDUpKnNEoq9XMbLaz240GZVDKoJRSSkm8mI8vgz8lic/wrI90y3m0Kwat0KBZM6jXfISqqFyVUXboI6KkemUglTd6JQ+UrF9wQcmGxgElG2UdULJxOgdKNrFyoGRTywElm9kOGJnMYy4YmSxiHhiZLOMeGJms4nm8zaKPbOA/ss5T1njKZK0RI5NNwuBjZn2XyVYjRia7pA9GJnuNXrLEb5kckgEYmRxTARiZnDRiZHLWhJHdIkZ2j37L3Hv2Ev2TXQBA4UXosEuApQAAAABJRU5ErkJggg=="
        id="aw"
        width={18}
        height={25}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABgCAYAAABlqZ4+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAACjklEQVR4nO2c204TURRAeZBADCGAGGIMBCIo0YiBaIT/f4ACiopauQip6E8wl+1pO1BC25nqnDm3WQ/7B1b2as5ZZ9Ix+bMj8ntbzXs170Su3or82hJpbXYmvXwj6cWGmteS/nwl6flLSc/W1byQ5ETNj+dqViVpPpPk+4qaZUm+LUnydVHi46fd+fJE4k8Lah6reSTx0axEH2bUTEt0OCXRQXseSrQ/KVFjQq73xuV694E3MzYc4lYOxAzkaRvkWg9iM4OYgYyPF3sQP99AVHM0L/HHuS7Iw+kexIMuxKgx7hXIEhAHbGLzziYOhXiziQMgZpsYeQSwAKJmnfsghq5za1SIa0Mh9m/hQr/KtxAzlYOCiM66IJrSOVSIGnS+hTiSzlN11Xl9uM6FR5wCnRvBQCypcwciOlejcxviQJ1DO+JUrvN8sc4egaxY57wjDjqPrnN77utcixvLvwSI/9SZAKFF57nAdaYnGtZZd0/sgKyzzgQId3piGBCNBwh6on6dCRAECIsBAp316+wRSHT2QmcChOHngfACBD3RPkQChKXnAQIEPdGpAOHTFpbWuZLnAQ9BWtaZAMEHTbkQjQcIf1Uu2EQChH2dCRA2AgQ6ozM6B6NzLW8s6GxIZ3oiPbF6nXkeKAmRnmhHZ3oizwMO60xPpCfmQqz6xsIHTQY+Nw7nN5EA4bbOHHEIEOjsFUQCBDq7sYn0RAIEOvsBkZ7omM5BQ+R5wBOd6YnonAuRAKFrE+mJ9nUmQBAgDOjMjQWdvYGIzujsxibSE+mJ6OwHRHqiYzoHDRGd0dkNiNxYykGkJ+raRJ4HNEBEZ/sQCRA8D7ixiQQIdDagMzcWdPYGYu3/8R2dTUAkQNydvwQbraFjIBRmAAAAAElFTkSuQmCC"
        id="ax"
        width={81}
        height={96}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAABACAYAAADbPd8FAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAD50lEQVR4nO2c6VrTQBhGcx20Se/KXdxBBNzFBUV7WSru4C4IChUVcANBq6jV35+TNlMm00lSmrRJZ94f5395nvN8yZx8g3V9Ww8BwLHS/gEgW0AI4ANCAB/WvT05ur2rh27uSP/HgPSxHh/I0+S+HN3fm6M7u3M0vrOHbmxP/4eBlISY7rfp+eE8PT2Up0dMjgkmB58a45gaxmGVhmx6fcymmaM2TfXZ9IzJ8eQgmxr78/WpcQtTwxispVMOvTvh0Jthm+YHbZodsMmdGi+ONE6N6iMFU0NrrLWLDq2MOPTxrENLpxvleKmQo/6+ATm0w9oYK1D5coG4GJ8EMRY8MV5BDGOw/hUL5FJh/BLlOL8px/uT4XLIp5S0/yiQgBCcv4zfVwv0g4nx7ZJDq0yMz+cc+nDGoUX2vvH2uEPii+h0X+2U4r6IPmQvohO9m6cUtI3uo0EIWQ53arhyrPOpweRY5lODyTE/VJsaM8LUULWNtP9QkIAQIn+uFejnldrU+HrBPzXc943ScG1qzEpTo/q+ganRNTQthIj7SOFyrHpToyqHNzXqj5T+zbZRnRpoG5mnJSHEqbHBxPg+WpsaX0ZqYohtY27QmxpyEe1FEc0isYQQqQhyrHlyVNuGLMeAQg7k8syQmBCyGOXRQlWMFYUYKKLZJXEhGuQY8+RQFNEFFNHM0VYh6mIUPTHiFlEcX/UQQpZDVUSXxSI6hCJqjBAcOXrJx1e5iE5JRfQB2oZeQshy8FwuyuFOjUWhiPK24U6NetvAtpd+QojI0avhO8owvqMYJUSQHHIuVz1S5G2vuyiiegnBqQQUUfE7ilxEVd9RcHzVRAgR/pEtMpejiJohhG9qjIUX0TkUUXOE8MlRRBGFEGFiYA0QQqjk4EV0PaKIYtvLACE4vIiWI9YA5YUefnx1i6h7fHVfRE04vmovhEqOsCKqahsmbXsZJYSIvO0VVkRN+o5irBDi1Ihz7UC3R4rxQojI216Ba4Aab5ZDiADCvqPonMshRARR0Uu3HVEI0YocEauA3VxEIUSLYuh6MRpCJChH3CKahVMKhEiQyLYRsCOapYUeCNEGwm7Nh91/zYIcEKLNqK44igs9pYC2IRfRTokBITqEqoi2eu2gnXJAiBTY6rZX0K35dhRRCJG2HMX44SvJIgohMkLc6JVUEYUQGSRMjqjwFfdyNITIME0V0YQvRkOILqFTRRRCdCFBbSPqPwI2s9ADIbqYZoqoaoFY3BGViyiE0IQtbXuFLPRACM2I+kcsqs1y8SMbhNCYVqIXhDCEZuWAEIYRVUQhhMGoLkdDCOCLXhAC+IAQwAeEAD7+A06GB2eqsd6CAAAAAElFTkSuQmCC"
        id="ay"
        width={132}
        height={64}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAVCAYAAACZm7S3AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABMklEQVR4nK2UyU6DUABF+xuOtYqllOnhbOOs1USrC4eVrvxtqq0tdIiNxi+4XhQIoQ1QdPF27/Duyb2h8PVcwsejhPd7GcOGgt6ZCmdfx9uWgZZh4mVVoLlowZ4ZP4UQvpUxuFTgnqjo7hHeIKwRlggvJMCfTxJGD2UMbyroX1ThHmno7BpoWyZeK4SXeHk24eWRF/uasetVOAc6OtuETcJlwsW02HeMffXr/BN7k7H1DM5jsY81dGs62ut8WTHRLKXF9mDG7p8z9iGddxhbEJb92ElwWFU9T1WB8+kfq3KCqtY8Z5HBOYwdqWoa50F8nlmqijq7UWeV8EqKc7SqXrQqy3fONM+481TzbMTmmaWqiQsLq+IHlgXsubxVpTn/7zwDZ1Zlz+epSvh/Em+eE5y/AU+kxrInTvO8AAAAAElFTkSuQmCC"
        id="az"
        width={15}
        height={21}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQklEQVR4nGP4Pt3tP7GY4cfcgP/EYoZfq5P/E4sZfm8v/k8sZvhzqPE/sZjh79n+/8Rihn9XZv4nFjP8uzr7P7EYADcOFnWlSldUAAAAAElFTkSuQmCC"
        id="aA"
        width={11}
        height={8}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAABGCAYAAACOjMdmAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACZklEQVR4nO2a2U7CQBSGfQ1XxIWdFsQN932NRhONJl6Y+NoCLoC7Rp/geIrTWMYBJE7paT0X5wG+zP9/kzlt18dFGN7Ph+HtbAReTyLwfBSFp8MYPO7F4WE7DvcbCaiuJqG6lILKQhrKs2m4nTbgZtKA65wJ1xkTrgycpAmleAZK0QwUR3GGM1AI4wxmoTCA05+Fyz6cXjE9Yrr1TFcdyOkovBxHvkD2Y/CwiyBbCbhbR5CVJFQWU1CeQ5AZA26nEGYCYcYETBpBEjgxhIkgyAjOkAAJKWA6BmKdyA6CbCLIGoIsixOxQPICZBxBsghh4qQEiONE6kBsiE6BqKJVA3FGK/8VrZucADEEiBStomfRsjty8A1yJzpSsUDmHR2RYlXriDNWdkdUsep4R+Ro2R1xRsuCMR0dsU9E0RHvorXjiNayIlrjcrRMdbRCXkXrL/qVo0VKv3K0ZP2a9fptFC3Wr1b9qjri1K/iZvdev4c/9VtV6TfXRL/WaYQbxKpXL0T70WqmXzlarF+XotWWflU3Oxn9qqI10+RmD4R+5WgFRb/eRatVR3TpVzOENv0qb3bWr9sdUei31pFW+iX9sAqSfuuiFVj9krzZf/OwCsReq5F+5WgFQr9eREubfsk8rFzYa5HsyK/0S/Jm971+m93sDfZa/tSvL/ZarF+7IxQeVqxfivpt1RGyywdNey3WL+tXh37ljpDTrwufFUh2hPVL6mEVpL0W65f1qzNaf/ysQLIjrF9+WLkULdYvP6zcjlYbnxVIgrB+Wb9ud4T126kTYf0S+arL+iWr3/+y1/LXP40+0u8nI+xe4lirmYsAAAAASUVORK5CYII="
        id="aB"
        width={50}
        height={70}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABcCAYAAAAvduizAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAE90lEQVR4nO3a917bMBDA8XuNLsqGEEICdEBpgQ4odO+W7va1Cwl7hfkE6hkriWMk+xzZsjz+0At8P7J/uYthbbDC1gbw9OPpw9Nrn9WecbbajecmP114boyzf9f5ucbPVTxXsnmgauH5AXbngGK8oQrrBLCJmGFAqA4jHgesSgDXeip0wAwhQrVQZk3AoYCAXdkGhOoI4hUqzHkD84gQ8WoXePz2DUtuXx/x9jUAM3L7oFYssyag+wY2APtzQDHeKOI1AEWP8IDgEe5xPcIZBYRaCeEagEUJIOUdmEFAqI0hWgNwVBEwYxGBWhnBnIDOd6DXT5j8HchgvYJYfoB5RCR442XmC5hHRII3gXgccF0GmEdEgjeJaF6AqhGRAaYgIrBxa4x5ApbyCnvibUyOtfAo78A8IhzvNuI5ASeIgNSIpBgQNu4gXANQ8AhLAamPcIorbOP5AAornEeEweZdjhcEMI9IC68J6MBri0iFGJGMjXKwOWXjCW9g0IhkrMKwOY1wfoAqEUnxKAdb90qsCTglAYwzIgYDwtZMiTUBpxUBMxYRKR4pImViRIL+J5yQvzRh6z7iUQDdEclHOcR7gHAOwLZ3YFgVTmlEYNvCcwLOEAGpEUnxPhC2Z0vMEzCPiAfe3CjbnrUODVAUEimg6xZ2BGjw521teJduYKcVzsgoB9vzCDfHjwQwkoikoMKw8xDR5vmRAVIjojrKJWwfCDuPRpkFuBMEUDUiKdkHIl6RXZxLgPSIZHUfCDuPOR6/gW680CKSwlEOdi08GWBYEUnpKAe7T4rMOkJA3RFJ2CgHuwsjbHdBDJiKiEQICHuLFp4IUBSRUh6RNrynCNcAtB5hr3dgFBERjHFJicgFXiDAOCJi6CgHe0s23iVA0yNiQIVhf7nAhICmRMTgfaCNtzzSAlwM4RF238CU7gNh/1mBXQKkvgOjvoGG7wNh/zniNQAdeO6fMG2AfnOwrn1gzBW28dyAS0RAwc+YrSA/YxI+ysHBC47nBHS/AxfUfwdq2QdqHuXg4GWBkQDDjojqv3IG7APh4NUwIwGaEpEwRrmQIsLxPABNiUiAfaAML+yIwOFrhKMAUiMiAwwyCydklIPDN8OMBEiNiKTC2v6V0/iVPhy+RbywAakVTvinHTaeCmCGRzmovxtidRFgXmFfQKi/RzwEbOJRb6AJEVH9tEOxwlD/gHidAgrfgfRRLtBG2sBPO+DIwnMDJiEiBnzaAUcfB1nogCZFRHWU83gHwtEnxBMA5hHxj4iNxwHrohvI8cgRMWGU07QPhOPPHM8PMIoKm7gPDDDKwfGXAeYGFL4DlSusaZTT+GmHjUcFTEKFNe4D4XiF4+kANKnCIUQETr4i2koLj/wOTFpEItgHIl4/6xgwSaNcBPtAOPlm4bkABY+wMmAEo5y2faBklIOT7whHBExsRKIY5fDAqYUXJ6BJEQlYYTj90ccswFMR4AoNMKujHJz+RDwOKL2BaY2I4j4Qzn4hHAUwiogojnJx7wMv8FQAtY1ycX7aIakwnP3uZZEA6ohIzKMcnP1BvCQDxjjKwbmF1wlgVKOcakQ07gPh/G8P6xjQwIjo3AfaeCEDJnofGKDCLTwdgCkb5drxTAc0KSJFEZ4KYJr3gYIbKMbTBZikUU7wCMvxTKuwgZ92eOOZ/g6MeZTzxzMdMMZRjoaXFsCQK/wfHvl8I2q8vzIAAAAASUVORK5CYII="
        id="aC"
        width={79}
        height={92}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAhCAYAAADQ1StpAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABiUlEQVR4nLXU21KCUBTGcV+j6TBjmIKKYFZWdrCDmllNp5nqIi96bVMSUazGaXqCr6Vsk0hgg3XB7X82v1lrRT6fovioCxg8rOD9NoHXCxHmSRLdwxQ6uzL0fAYvWQUtSUFTUPG8mEVjbvJFRoFHCtxT4IYC5xLMCgUO0ujsyGhvUEClgKiiuayiseAVuBbRP5PQK1OgSIECBdYpoPgGYhjcxfF2SYFTCpRSMPYpsG0FtAwFEvT8aNYlUGcvYAb9qoTuEUWGBpvMIBnEYIw4NMgzA4nLgAJkYJYZYoEh+hsIlsEVPb/mbtCMugWmGPSOKbLHDFZnMNC/DZTRL3gHxgbOQeI1GA1SzRoko+gwEAMYmNUkM0hD37IMNH6DyTIZ9mXiCrgZBBmkacukKTMatHMUSdEvxIIY2Jcp8CBV3JeJD9G+THYD7kEq2QZpjQKy7aDMhzQIgPjTINwghToojqv8a5k8j6qfQY4M0sxgKaQB3zb+2zL9lUErHtZgfJF8B8nTIOwg+RyUL+uhs8uF+dkmAAAAAElFTkSuQmCC"
        id="aD"
        width={16}
        height={33}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAdCAYAAAAtt6XDAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABhklEQVR4nO2X2U7CUBRF+Q0nEGQstLeIE4gzKuIQjUaiwcT42wIig6Li9AXbjWmEMFRIi0rsw3nuylo3Oae29ysn3i5deM248XLmQe3Ui6djHx4P/XjYC6C6E8D9loTKRhCV1RDKSzJKMRnFBQW3swoKYYEbhSMJ5H0qcm6OU0XWEcb1OGeUM9Lf2L6gLgh17sFzmlAnhDoi1IEf1V1CbUu42yTUehDllRBKcUJFCTXHiRBMJVSIUAGBnIdQLkJNhpGd4EfGjELVTaWbTO3TVEqDShBqjaaWaWqxydS0QEEQKkgov9qAcmhQhkx1y5fqkm+eUDM/lK/Wmi/VT74Opqx8OvmyTgLZrXzDkk8m0K/lq5salnyfD71DPlPXTK11zSTrpqTGQ2fCYkxpT8g1k/cSakpbM3YzTLXmazY19PkGcSV8my/eYz5TTOnlS+jkEzr5DJsymm+QR17f+VQrn5XPvHyFiGjkM/1K+Ov52n6xkh2OvJj20K18BvKZfuT1nC/6z/J9AIl3bcfhhE9/AAAAAElFTkSuQmCC"
        id="aE"
        width={37}
        height={29}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAWCAYAAAAmaHdCAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABiklEQVR4nI2UV5aCQBBF3f9KZlRQlGAERcCEETGh6KzkTTfSKEHgo3/vefVuVVecgwt7vYE5nUEb6+gNhhBlBY1WGzW+gZ9avfBVTucLNrs9ZosldMPEQNUgd7oQ2iLqjSZ+y0C8uw/HPQZprNkcI31C0qgQlQ6aJdNU/OcfzlcP272D+dKGboZpuj0IogSuRJoAcvcfcI+nKA3tptsfoC0p4JsCqnWuGELfxbth5xywsFcwLAtDbQSl10eLpckBRRD/8YR7OmO93WE6X4TdvEzxQis3zRsSptkT5cvVmiifQh2N0aFpJBkcGetbmhiEFpzSTQsu0B2DUN2HRMHBSER33vLFIPGCbUzMsOAC3SkI073abD8KViHlLF8KQt/1do8KNqxEwRm6MyFJ3eOJgf5Qg8RuKpEmGxKWzG6KXfhri+XUFn+F0DTHrAvPUP4dQt6NlJypnG0xxxdD4gUn7uljpFzI5zfBRgoKTuguhHgkjZO6p3jBhZBoi0kausWxTyvUXQqSrftd8D+0NM6yQBgHXQAAAABJRU5ErkJggg=="
        id="aF"
        width={17}
        height={22}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABEklEQVR4nJ3QWXKCQBSFYfe/klTFVEjQMAiIiszzjIKYlZy0WEEwbcrioR/Pfz+Ync7foL72jGPdoKgOSPMCYZzA9QNYjoO9YWCz0yCvVcweBepTi/JwRJrlCKIYjufDtB1ougF1u4OkrMGLEj3QkOuHY428LBEnKfwwgu160E0LW20PRd1AkGQseYESGNLJ9Qvd6+lmTxdWEpYcPw50l8k4LyskadbTDcsmdH1EX5Axwy4ogSfpH2T89s4MAhS6+w99FJhCn5Pxy+t8EOjoFWISoNHFO/pl3AWatkVFxllRIiLf7QUhYbtXtqZdx7ICThDBfnFgPtn+ehd4jr76Q78FJtL7AJX+4I/fj7vAVPrv+wFRAOxrwfkhCgAAAABJRU5ErkJggg=="
        id="aG"
        width={16}
        height={14}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAyCAYAAAC+oOBfAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB7ElEQVR4nO3Vx3qCQBiFYe7/Soy9gYK9915ijCW5kpMZkJ8SwFFn6YLt+5wPxlG5/PxC6Ln+4Hg6Y3/4wma3x2K1xnS+wGgyRX84QqfXhyKKnc4XHI5HbPefWK43LmiIdq+HRrsjhp2vV3x9n7D7PGC12WK+XGEym2EwGqM3YFiXYa22AMbzGMTz1ttdYF6Trao3W/ex0+UakjeivGqjCaNai8ai8rr9AeVV6w3olWoEJphXY3mVWh1loxKM8UUmxBZxyFo0x3A8sV64L6/EILVUDsceydPKBgpaKQB7IM+45fFVeVXzYnfzur483bCgooZsvvAfeyYvVygik8s7mHWevrFj54lDs8US46kDtTpd82DaX04t6yiwtCyD0tkckpmshdmLIvP4Ilde0ZWX4lg648XC8viqqDy+Kp5KQ3k5jy3i0EciCUVGXjyZQoxjIreBucrM0wPzPmxMRl7s9iiReeyFe/NUZG55CYbZiwgTzlMD8hI+TEYeYWF5+gN5hD1yMBOuL3cXE8kLg0xMRh5h9qJX8gjjl13Nd5fzW5P/XETzHMyVpz2ZR9i9a8V/MCMxGXmEycgjTEYeYe6/qmfzCCuyVa/mESYjjzBP3pOLCHs1zYPJyHMwCXmEychzMAl5hMmC3tgbi3j+ABl4xCRObKOuAAAAAElFTkSuQmCC"
        id="aH"
        width={19}
        height={50}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAALCAYAAACgR9dcAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAt0lEQVR4nLXRyQqCABDGcV+jaKGyxN2gDaI8tBxaTtapW69tWamZUgQ9wdcc1INBotFhbvNnfjDMa1/Dc8fivuEQrHh4MxHuSMalp+CkqDg2NRwqbZiFz2Hi2ODgL3hcJyKcIcUdiiWKWYrLKfFj20Kw5nGbC3B1CfZAwVlTYXEUV2m5+O1yxJ7mZS8TbJHiRga2l5fth2wnYss/sC2B4roGs5TGjv9M7LEMu5+FbSTY3ZDN/on9Bo7vc9rXNTFAAAAAAElFTkSuQmCC"
        id="aI"
        width={15}
        height={11}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA6CAYAAADRN1sJAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADa0lEQVR4nMXW/2uNURzA8UNKflL7vlprLcaeL/febTbb7rXtXhEhYm2xpskiIiIiEYlIJBKJJJJomu+iCZEvUfIlyR/z8Tnm6Jxzz3PPeZ7nzP3h8+Nzz6un+3zeh2RyKWjHacHxcGbh1OPU4JRkUzANZwrOJBzSQyc5Pt2WpgcPKipiAR7CI5olRPVEI5bgAWERxCZiOf74YgnR9j8Rq3JJWGaAqJsoRH82CSpE2gAx2QZiAAEUsdIA0WCCCAsYwoeCEN0GiKlxEcP4AEP0GSBc24hN3QlgiDUKxPyJRmztSgBDrM3mIxYpECkFYnpUxI5MAoqK2J32gUesVyCWKhCtCkRlNgLiYLsPezt92JXxYfu8BGxByAZ8YB3OIAJW/90TdGPStb1QWtuxA3akzYOiIo63eEARByTEZgnRLyF0ATNGnEp5QBGH5/oCYpuEGIiAMGrHWd8Fijg2R0TsxD+mDmGlohccFyjiZJMeMSQhrFT0coMLFHEmkY/YkxYRwwaI0BW9VucARZx38xH7O0QEv7bjBExA3Kx2IAhxSELwG9NawEZKHGCIS7NFxNFWESGv7TgBYxuTjJY6wBBX610BcaJZRMhr20Y7yP1SF4IQp5MiYl9nPiJuO8ijMg94xI2aYARd2TyCruyNuExkxAr8cRnRoUDU4pCn5R4UQpzzghGsGzyCdqM3l4/oUiBmUMBYuQ8y4nZ5MILFKwgxGIDIKRCNFPCqIgHPEfEM5wkiHpa5cA8hd/BN3Kp04HqtA1dmunCxcXxjsnaYVrRXqmguJ1aUvEHASwXiLr4JGcHWNo/QVVSXcvKuMgkqxAMFgq1tHqGrqC7l5AMCKOK1AYJtTB4Rt6LkEx4ehHhsgNAFTFdR8rkqBWEQfDuiVpRf2+QLAnjEWzycR9BPNCxCV1F+bZPvVU0QFjEiIeJUlPyoboJiINjaJj8RQBHf8HAe8V5CjEmIUQkRNuWsHeQXHl4MBGvHH4AtRNj7BEX8A5giXlT4AqLQfUKHoAETAEGIjzEQuktNHsAGotClRkYoATyCfqJfpU80KGCqiuoCFgiIijCpKL+2CwJMEHErqgVEQYSpqBFARshrO0pFGcIYoEPI7TBNeShAWIQuYBQRGmAbEQlgExEZYCtgsQA2ELEBcRFWAHEQ1gBREb8Byh8sOs182pkAAAAASUVORK5CYII="
        id="aJ"
        width={32}
        height={58}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAXCAYAAAAC9s/ZAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB50lEQVR4nJ2SzUtUURiHTxiEq8hJx7GFH4TKPfdr/MrvaRTSUMQKEdFCAqkwoqJaqKhIQUUU5MJEEkSwTYFBboxctCgocOEiBP+Yn7/D3Oscr1Pd6+LZnfPwvO85Ii/t4gQRFxVOhlQETvPyKaJEQheFFZR3uCghZ3g5n5yMWiR5uZIoUcIT+UWhRA28VENMUuWJVFEsbFE7DzeTepL0RMGi/H8VXeahTpIiLSRYVPG/omsdDvp4oId0kTRpI02kjjhE7ek8KfWqDr3ccNrBILmqiS5FEInbnOMmU25QMkQGyBXKenkgzHjifpuNu+02jisSE80WHrda8EW3IorE0wYT040Wwoj6c4jEqxoTz+tM6KJHrfYR0fUcom4lWDQk5i2JN66Jl7UmnlE0S9FUk4UnLRYeUnaPojspG2MUjZIR7+XUFxBr5wysVEgsVUssSIm3toRfNXfBOlI1HqgS6zEDH8mHkozofZXEOyMjep3Mjjej7emB9nJis9DEl7MSvihqkfheZGOr0IISbVD0OSYPilbLjIMitSdV9EIrmqRI/I47+EGJEn3TRLlG84v00cROsYvtuAsl+hnPiFTRV63oU0G2aLkyW6ReTuwmkvhTnIQu8ov+Npq+bLFHgU9Q9ivHeMGF7wOA8n991wZ4kgAAAABJRU5ErkJggg=="
        id="aK"
        width={16}
        height={23}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAALCAYAAACUPhZAAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB6UlEQVR4nI2TyU9TURhHn4JuDDESXRiKGhDF3vsGoC1TS1uccGDUKIoKDhEURMWocRZxRIJG0RhYiAt0QfwbP861t+kDMbg4y3ty8vvec5y0L3+RMQRSnA1kC+xoDWQvBFAPLXAQjkNPqy+9WV8uwBXeDbd4civlyb1mV5zV5YGsR1oCZQiqwIU4JGE/tEEnnEJ6Di4hHkp7Mor4btKVR00r5f8oroEGSMMhW3yC4jNI+zOF4tuI71P8pNGViURYbsQIN8JWqECgIAbNtvbIitqLf2p9GUV8J+nJA2qfNbjyKqHlfZ22cmrXIdwE23lcCdqKmyBrZ2i3xWcRDyAe5O0NK36I+Dni13EtU7VaPrsKOeIipJshwuM94EPCHu4AHIMuOI30PFxGfI19b5p9meExM7yod+VtTMt0jZYZxLP7kG9AWgo7eVwNtdAIGThsa0/aWjPDVRihdszO8JTal8wwyQwfAiVftJK5aiU/KpCvVdyNOF9sDnc9XfjUTPEExe9iRqxzYornK5X8jETF2YUgGirO79thi/tscXjf8OFM8UdfyVdVKP5VFpXFbcjN4epCh8tPsdqnNpYqiPOH++Qp+RZV8r1KyUJ5Tvq7NIdjfoyU/dSO/sePMc4Mb+LLDze/G3FkudiwBOcvts6Yx6BlAAAAAElFTkSuQmCC"
        id="aL"
        width={23}
        height={11}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAPCAYAAAAceBSiAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABOklEQVR4nMXTzysEYRzH8S2Uf0Bp/WZ/mJ3dmRI5CZtl2WHN7M7zJEoSJcWFkpOSk5KTkpOSm5ITf93HZw5b27bP/jDP5PA9v1/N85nYaWUaB24GYtuEs5VF3slhvmTBXLcxsmajv2AjluctRnD3Ygo3fhKX1TRaQeKrNvpWNENe5RiexATaIeY2LBhFzYgfEceHHIYKsU+ET0SJiCXdiCAe3HcLxEnFiAZRi/8LojEeBpEmYpCI3gCxHCJef19yCO9yFC9yHI9iEncigWs/hXNu4tgzsEeIV86iuJnDgmNhhpBkJ5BO4rX75JdQIY6I2HVNuE0QA0T0NEN0E2/3JBeKJ5lVPclf4toQYeJhEVrijbt44y6euYsH7uLWT+CqmsIZd3HoZbBDRJm7KHAX2uPdICKLqxD1f8gvW4NXx2LrrZ8AAAAASUVORK5CYII="
        id="aM"
        width={31}
        height={15}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAUElEQVR4nGNgsNf/TzKWd9f/TypmcPPV/U8qZkgK0vpPKmaoCVX7TypmmBCm9J9UzLAwXP4/qZhhbbjMf1Ixw9Yw6f+kYoadYVL/ScWDXBMAkHZMlAl806wAAAAASUVORK5CYII="
        id="aN"
        width={13}
        height={13}
        preserveAspectRatio="none"
      />
      <clipPath id="a">
        <path fill="#fff" d="M0 0h504v290.779H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default Logo;
